<template>
  <v-app >
    <!-- menu de gauche -->
    <v-navigation-drawer
      app 
      fixed
      v-model="drawer" 
      :mini-variant="mini"
      class='position-index-11'
    >
      <v-list class="pa-0">
        <v-tooltip right>

          <v-list-tile
            avatar
            tag="div"
            slot="activator"
            href="https://www.targetfirst.com/"
            target="_blank"
          >
            <v-list-tile-avatar>
              <v-img src="../../static/notif_icone.png"/>
            </v-list-tile-avatar>
          </v-list-tile>
          <span>Target First</span>
        </v-tooltip>
      </v-list>
      <!-- MENU -->
      <wz-menu></wz-menu>
      <div class="sessionTimer">{{ remainingFormatted }}</div>
      <!-- Version -->
      <v-footer absolute color="transparent" v-if="true">
          <v-chip
            label
            disabled
            small
          >v{{myVersion}}</v-chip>
      </v-footer>
    </v-navigation-drawer>
    

    <!-- Aide en ligne -->
    <v-navigation-drawer
      disable-route-watcher
      app
      fixed
      v-model="helper" 
      right
      temporary
      width="350"
      class="position-index-11"
      hide-overlay
      >
      <wz-help :opened.sync="helper"></wz-help>
    </v-navigation-drawer>

    <!-- Questionnaire de satisfaction agent -->
    <v-navigation-drawer
      v-if="false"
      v-model="showSatisfactionAgent"
      disable-route-watcher
      disable-resize-watcher
      app
      fixed
      right
      hide-overlay
      width="350"
      class="position-index-11"
    >
      <wz-satisfaction-agent
        :opened.sync="showSatisfactionAgent"
      ></wz-satisfaction-agent>
    </v-navigation-drawer>


    <!-- TOOLBAR AVEC DES TABS OU AVEC UN SOUS-TITRE ET SA FLÈCHE DE RETOUR -->
    <v-toolbar
      app
      dense
      class="position-index-10 "
      id="toolBarApp"
    >

      <v-toolbar-side-icon
        dark
        @click.native.stop="drawer = !drawer"
      ></v-toolbar-side-icon>
      <v-toolbar-title class="white--text">{{ title }}</v-toolbar-title>

      <v-spacer></v-spacer>
      <!-- Gestion de l'état du pupitre -->
      <wz-pupitre-status v-if="!isMobile"></wz-pupitre-status>
      
      <!-- Gestion des notifications -->
      <v-tooltip bottom>
        <template slot="activator">
          <wz-notifications></wz-notifications>
        </template>
        <span>{{ $t('dashNotif') }}</span>
      </v-tooltip>
<!--      
      <v-tooltip bottom v-if="checkPermission('NO_AGENTS') && !isMobile && !$vuetify.breakpoint.smAndDown && $store.state._User.connexionType !== 'freshdesk'">
        <template slot="activator">
          <v-btn
            icon
            @click="installProgress = true"
            :dark="$store.state._User.connexionType  == 'freshdesk' ? false : true"
          >
            <v-icon>explore</v-icon>
          </v-btn>
        </template>
        <span>{{ $t('visitGuidee') }}</span>
      </v-tooltip>

      <v-tooltip bottom v-if="!isMobile && !$vuetify.breakpoint.smAndDown && $route.path.indexOf('botbuilder') === -1 && $store.state._User.connexionType !== 'freshdesk'">
        <template slot="activator">
          <v-btn
            icon
            @click="showHideMydesk()"
            :dark="$store.state._User.connexionType  == 'freshdesk' ? false : true"
          >
            <v-icon>forum</v-icon>
          </v-btn>
        </template>
        <span>{{ $t('dashChatbot') }}</span>
      </v-tooltip>

      <v-tooltip bottom v-if="!isMobile && !$vuetify.breakpoint.smAndDown">
        <template slot="activator">
          <v-btn
            icon
            dark
            @click="bugReport()"
          >
            <v-icon>bug_report</v-icon>
          </v-btn>
        </template>
        <span>{{ $t('dashBug') }}</span>
      </v-tooltip>

      <v-tooltip bottom >
        <template slot="activator">
          <v-btn
            icon
            dark
            @click.native.stop="helper = !helper"
          >
            <v-icon>help</v-icon>
          </v-btn>
        </template>
        <span>{{ $t('dashAide') }}</span>
      </v-tooltip>
    -->
      <!-- Gestion de l'état de connection de l'agent sur le chat -->
      <wz-agent-status></wz-agent-status>

      <!-- menu gestion agent (deconnexion, modif profil, alert.....-->
      <wz-agent-menu></wz-agent-menu>

      <v-tabs
        v-if="($store.state._Toolbar.tabs.length) || (back && subTitle)"
        slot="extension"
        show-arrows
        class="tfSousMenu "
      >
        <v-tabs-slider color="accent" style="height: 4px;"></v-tabs-slider>
        <!-- SI SOUS TITRE -->

        <v-toolbar-side-icon
          v-if="back && subTitle"
          @click="$router.push({ path: back })"
        >
          <v-icon>arrow_back</v-icon>
        </v-toolbar-side-icon>
        <v-subheader v-if="back && subTitle" class="subheading">{{ subTitle }}</v-subheader>
        <!-- SI ONGLET -->
        <v-tab
          v-for="tab in $store.state._Toolbar.tabs"
          :key="tab.title"
          :to="tab.to"
          exact
          class="mr-3"
        >

          <div>
            {{ $tc(tab.title, 2, { count: '' }) }}
          </div>
          <v-badge
            class="badgeTopMenu"
            v-if="tab.to == '/trafic/chatting'"
            right
            color="accent"
            :value="tab.to == '/trafic/chatting' && $store.state._StoreWatcheeBox.sessionsPrivees.length"
          >
            <span class="caption" slot="badge">{{ $store.state._StoreWatcheeBox.sessionsPrivees.length }}</span>
          </v-badge>

          <v-badge
            class="badgeTopMenu"
            v-else-if="tab.to == '/trafic/attente'"
            right
            color="accent"
            :value="tab.to == '/trafic/attente' && getMessageAttente"
          >
            <span class="caption" slot="badge">{{ getMessageAttente }}</span>
          </v-badge>

        </v-tab>
      </v-tabs>
    </v-toolbar>
    
    
    <v-content
      :class="{
        'contentVuePages': !isMobile,
        'contentVuePages-mobile': isMobile
      }"
      v-resize="viewSizeScreen"
    >

      <!-- alert licence non activée -->
      <v-alert
        v-if="!licenceURL"
        :value="true"
        type="error"
        id="alertLicenceInactive"
        :style="$vuetify.breakpoint.mdOnly || $vuetify.breakpoint.smOnly || $vuetify.breakpoint.xsOnly ? 'width: 100%;' : 'width: calc(100% - 80px);'"
      >
        {{$t('activeLicence1')}} <a href="#/management/sites">-> {{$t('activeLicenceURL')}}</a>.
        <br>
        {{$t('activeLicence2')}} <a href="https://support.targetfirst.com/?s=installation" target="_blank">{{$t('activeLicenceFAQ')}}</a>
      </v-alert>

      <transition name="slide-x-reverse-transition" mode="out-in">
        <router-view></router-view>
      </transition>
    </v-content>

    <!-- NOTIFIER GLOBAL -->
    <wz-notifier></wz-notifier>

    <!-- dialog visiteur offline -->
    <v-dialog v-model="dialogVisiteurOffline" persistent max-width="290">
      <v-card>
        <v-card-title class="primary white--text subheading">{{ $t('visitorOffline')}}</v-card-title>
        
        <v-card-text v-if="visiteurChangePage">
          {{ $t('trasfertChangePage')}} 
        </v-card-text>
        <v-card-text v-else>
          {{ $t('transfertOffline')}}
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            v-if="visiteurChangePage"
            class="accent"
            flat
            @click="closeDialogVisiteurChangePage()">{{ $t('ok') }}
          </v-btn>
          <v-btn
            v-else
            class="primary"
            @click="closeTransfertClient()">{{ $t('close') }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- DIALOG GLOBAL -->
    <wz-dialog></wz-dialog>

    <!-- dialog transfert -->
    <v-dialog v-model="dialogTransfere" persistent max-width="290">
      <v-card>
        <v-card-title class="primary white--text subheading">{{ datasTransfere.msg ? datasTransfere.msg : '' }}</v-card-title>
        <v-card-text>
          {{ $t('findNewChatInChatting') }}
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn class="accent" flat @click="rejetTransfertClient()">{{ $t('cancel') }}</v-btn>
          <v-btn class="primary" @click="acceptTransfertClient()">{{ $t('submit') }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- dialog reconnexion -->
    <v-dialog v-model="dialogReconnexion" persistent max-width="290">
      <v-card>
        <v-card-title class="primary white--text subheading">{{ $t('connectionInterrupted') }}</v-card-title>
        <v-card-text>
          {{ $t('noLongerConnected') }}
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            v-if="sessionDejaActive"
            class="primary"
            :disabled="!btConnexion"
            @click="reconnexionBO('Connexion Internet interrompue avec multisession')"
          >{{ $t('reconnection') }}</v-btn>
          <v-btn
            v-else
            class="primary"
            :disabled="!btConnexion"
            @click="reconnexionBO('Connexion Internet interrompue')"
          >{{ $t('reconnection') }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- dialog reconnexion -->
    <v-dialog v-model="dialogScript" max-width="290">
      <v-card>
        <v-card-title class="primary white--text subheading">{{ $t('dashOups') }}</v-card-title>
        <v-card-text>
          <p v-if="noMainSite">{{ $t('scriptInstallationNotOk3') }} <br><a href="https://admin.targetfirst.com/#/management/sites"> {{ $t('scriptInstallationNotOk4') }} </a></p>
          <p>{{ $t('scriptInstallationNotOk') }}</p>
          <p>{{ $t('scriptInstallationNotOk2') }} <a href="https://support.targetfirst.com/?s=installation" target="_blank"> article</a></p>
        </v-card-text>
        <v-card-actions>
          <v-btn
            block
            class="primary--text"
            flat
            :loading="isChecking"
            @click="checkScript()"
          >
            {{ $t('testAgain') }}
            <v-icon right>refresh</v-icon>
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- dialog multi connexion sur un compte -->
    <v-dialog v-model="activeDialogMultiSession" persistent max-width="290">
      <v-card>
        <v-card-title class="primary white--text subheading">{{$t('titleDialogMultiSession')}}</v-card-title>
        <v-card-text>
          <div v-html="checkPHPsessionID ? $t('contentDialogMultiSessionPhp') : $t('contentDialogMultiSession')"></div>
        </v-card-text>

        <v-card-actions
          v-if="!checkPHPsessionID"
        >
          <v-spacer></v-spacer>
          <v-btn class="blue--text darken-1" flat @click="logout()">{{$t('no')}}</v-btn>
          <v-btn 
            class="blue--text darken-1" flat
            @click="reconnexionAgent()">{{$t('yes')}}
          </v-btn>
        </v-card-actions>
        <v-card-actions
          v-else
        >
          <v-spacer></v-spacer>
          
          <v-btn 
            class="blue--text darken-1" flat
            @click="debloqueMultiSession()">{{$t('unblock')}} ( {{ formattedTime }} )
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- dialog quota pages vues -->
    <v-dialog v-if="usrBoNotif === '1'" v-model="activeDialogPagesVues" persistent max-width="480">
      <v-card>
        <v-card-title
          v-if="LicenceOUT"
          class="red white--text subheading"
        >
          {{$t('warning')}} {{$t('warningLicence')}}
        </v-card-title>
        <v-card-title
          v-else-if="fullQuotaPagesVues"
          class="red white--text subheading"
        >
          {{$t('warningTracked')}}
        </v-card-title>
        <v-card-title
          v-else-if="fullQuotaChats"
          class="red white--text subheading"
        >
          {{$t('warningTrackedChat')}}
        </v-card-title>
        <v-card-title
          v-else-if="expireLicence"
          class="red white--text subheading"
        >
          {{$t('warning')}} {{$t('warningExpired')}}
        </v-card-title>
        <v-card-title
          v-else-if="sursisLicence"
          class="red white--text subheading"
        >
          {{$t('warningExpired')}}
        </v-card-title>
        <v-card-title
          v-else-if="$store.state._User.entBusiness=='pv'"
          class="orange white--text subheading"
        >
          {{$t('infoConsumption') + quotaPages.toFixed(2) + ' %'}}
        </v-card-title>
        <v-card-title
          v-else-if="$store.state._User.entBusiness=='chat'"
          class="orange white--text subheading"
        >
          {{$t('infoConsumptionChat') + quotaChats.toFixed(2) + ' %'}}
        </v-card-title>

        <v-card-text
            v-if="LicenceOUT"
        >
          <h3>{{$t('txt1WarningLicence')}}</h3>
          <br />
          <p>{{ $t('txt2WarningLicence') + supportEmail}}</p>
        </v-card-text>

        <v-card-text
          v-else-if="fullQuotaPagesVues"
        >
          <h3>{{$t('txt1AlertQuota')}}</h3>
          <br />
          <p>{{$t('txt2AlertQuota')}}</p>
          <p>{{$t('txt3AlertQuota')}}</p>
          {{$t('txt5InfoQuota')}} <b>{{$store.state._User.entNbPageMax}}</b><br />
          {{$t('txt6InfoQuota')}} <b>{{(renouvellementDay) ? $t('in')+' '+renouvellementDay : ''}} {{$tc('daysQuota', renouvellementDay, {count: ''})}}</b><br />
          <p>{{$t('txt2ExpireLicence')}}</p>
          {{($store.state._User.entRefFacturation) ? $t('referentFacturation') + ' ' + $store.state._User.entRefFacturation.CLI_EMAIL : ''}}
        </v-card-text>

        <v-card-text
          v-else-if="fullQuotaChats"
        >
          <h3>{{$t('txt1AlertQuotaChat')}}</h3>
          <br />
          <p>{{$t('txt2AlertQuota')}}</p>
          <p>{{$t('txt3AlertQuotaChat')}}</p>
          {{$t('txt5InfoQuotaChat')}} <b>{{$store.state._User.entNbPageMax}}</b><br />
          {{$t('txt6InfoQuotaChat')}} <b>{{(renouvellementDay) ? $t('in')+' '+renouvellementDay : ''}} {{$tc('daysQuota', renouvellementDay, {count: ''})}}</b><br />
          <p>{{$t('txt2ExpireLicence')}}</p>
          {{($store.state._User.entRefFacturation) ? $t('referentFacturation') + ' ' + $store.state._User.entRefFacturation.CLI_EMAIL : ''}}
        </v-card-text>

        <v-card-text
          v-else-if="expireLicence"
        >
          <h3>{{$t('txt1ExpireLicence') + ' ' + dateExpire}}</h3>
          <br />
          <p>{{$t('txt2ExpireLicence')}}</p>
          {{($store.state._User.entRefFacturation) ? $t('referentFacturation') + ' ' + $store.state._User.entRefFacturation.CLI_EMAIL : ''}}
        </v-card-text>

        <v-card-text
          v-else-if="sursisLicence"
        >
          <h3>{{$t('txt1ExpireLicence') + ' ' + dateExpire}}</h3>
          <br />
          <p>
            <b><i>{{$t('txt3ExpireLicence')}}</i></b><br />
            {{$t('txt4ExpireLicence') + ' ' + $store.state._User.surcisLicience + ' ' + $tc('days', $store.state._User.surcisLicience, {count: ''}) + ' ' + $t('txt5ExpireLicence')}}
          </p>
          <p>{{$t('txt2ExpireLicence')}}</p>
          {{($store.state._User.entRefFacturation) ? $t('referentFacturation') + ' ' + $store.state._User.entRefFacturation.CLI_EMAIL : ''}}
        </v-card-text>

        <v-card-text
        v-else-if="$store.state._User.entBusiness=='pv'"
        >
          <h3> {{$t('txt1InfoQuota')}} {{quotaPages.toFixed(2)}} % {{$t('txt2InfoQuota')}} </h3>
          <br />
          <p>{{$t('txt3InfoQuota')}}</p>
          <p class="red--text">{{$t('txt4InfoQuota')}}</p>
          <p>
          {{$t('txt5InfoQuota')}} <b>{{$store.state._User.entNbPageMax}}</b><br />
          {{$t('txt6InfoQuota')}} <b>{{(renouvellementDay) ? $t('in')+' '+renouvellementDay : ''}} {{$tc('daysQuota', renouvellementDay, {count: ''})}}</b>
          </p>
          {{($store.state._User.entRefFacturation) ? $t('referentFacturation') + ' ' + $store.state._User.entRefFacturation.CLI_EMAIL : ''}}
        </v-card-text>

        <v-card-text
        v-else-if="$store.state._User.entBusiness=='chat'"
        >
          <h3> {{$t('txt1InfoQuota')}} {{quotaChats.toFixed(2)}} % {{$t('txt2InfoQuotaChats')}} </h3>
          <br />
          <p>{{$t('txt3InfoQuotaChat')}}</p>
          <p class="red--text">{{$t('txt4InfoQuotaChat')}}</p>
          <p>
          {{$t('txt5InfoQuotaChat')}} <b>{{$store.state._User.entNbChatMax}}</b><br />
          {{$t('txt6InfoQuotaChat')}} <b>{{(renouvellementDay) ? $t('in')+' '+renouvellementDay : ''}} {{$tc('daysQuota', renouvellementDay, {count: ''})}}</b>
          </p>
          {{($store.state._User.entRefFacturation) ? $t('referentFacturation') + ' ' + $store.state._User.entRefFacturation.CLI_EMAIL : ''}}
        </v-card-text>

        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer> </v-spacer>
          <v-btn
            color="primary"
            @click="souscrire()"
            v-if="!LicenceOUT"
          >
            {{$t('help')}}
          </v-btn>
          <v-btn
            color="primary"
            :href="Support"
            target="support"
            v-else
          >
            {{$t('support')}}
          </v-btn>
          <v-btn 
            class="blue--text darken-1"
            flat
            @click="continuer()"
          >
            {{$t('continue')}}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- dialog c2c -->
    <v-dialog v-if="usrBoNotif === '1'" v-model="activeDialogc2c" persistent max-width="480">
      <v-card>
        <v-card-title
          v-if="C2CoffF || C2CoffM"
          class="red white--text subheading"
        >
          {{$t('warning')}}
          <br>
          {{$t('warningC2C')}}. {{$t('infoConsumptionC2C') + ((depassementF > depassementM) ? depassementF : depassementM)+ ' %'}}
        </v-card-title>

        <v-card-title
          v-else-if="C2CnearF || C2CnearM"
          class="orange white--text subheading"
        >
          {{$t('warning')}} <!-- Attention :-->
          {{$t('warningC2Cnear')}}. <!--{{$t('infoConsumptionC2C') + ((depassementF > depassementM) ? depassementF : depassementM)+ ' %'}}--> <!-- La fonctionnalité de click-to-call sera prochainement désactivée. Consommation actuelle : 81 % -->
        </v-card-title> 
        <v-card-text>
          <h3>{{$t('txt1InfoQuota')}} <br>- {{depassementF}} % {{$t('txt2InfoQuotaC2C')}} {{$t('fixes')}} <br>- {{depassementM}} % {{$t('mobiles')}} </h3> <!-- Nous vous informons que vous avez atteint 81 % de votre quota d'heures vers fixes et 81 % vers mobiles -->
          <br />
          <p class="red--text" v-if="C2CnearF || C2CnearM">{{$t('txt4InfoQuotaC2C')}}</p> <!-- Attention, la fonctionnalité sera coupée si vous atteignez votre quota d'heures de communication.--> <!-- commenté car on trouve plus la tradution -->
          <!--<p class="red--text" v-if="C2CnearF || C2CnearM">{{$t('warningC2cReste')}} {{Math.round(c2cAverageF/60)}} {{$t('warningC2cReste2')}} {{resteEstimedF}} {{$t('warningC2cReste3')}} {{resteEstimedM}} {{$t('warningC2cReste4')}}.</p>-->
          {{$t('txt5InfoQuotaC2C')}} <br><b>{{ $tc('hours', $store.state._Sites.siteSelected.c2c_quota_sites_f, { count: $store.state._Sites.siteSelected.c2c_quota_sites_f })}} {{$t('tofixes')}} <br>{{ $tc('hours', $store.state._Sites.siteSelected.c2c_quota_sites_m, { count: $store.state._Sites.siteSelected.c2c_quota_sites_m })}} {{$t('tomobiles')}}</b><br> <!-- Vous disposez actuellement d’un quota de 3 heures vers téléphonie fixe et 3 heures vers téléphonie mobile-->
          <br><p>{{$t('txt3InfoQuotaC2C')}}</p> <!-- Nous vous invitons à suivre votre consommation et souscrire à des heures de téléphonie supplémentaires. -->
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="primary"
            @click="souscrireC2C()"
            v-if="!LicenceOUT"
          >
            {{$t('help')}}
          </v-btn>
          <v-btn
            color="primary"
            :href="Support"
            target="support"
            v-else
          >
            {{$t('support')}}
          </v-btn>
          <v-btn 
            class="blue--text darken-1"
            flat
            @click="continuerC2C()"
          >
            {{$t('continue')}}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- dialog Carte de credit valide -->
    <v-dialog v-if="usrBoNotif === '1'" v-model="activeDialogCB" persistent max-width="480">
      <v-card>
        <v-card-title
          v-if="expireCB"
          class="red white--text subheading"
        >
          {{$t('warning')}}
          <br>
          {{$t('cbExpire1')}}
        </v-card-title>

        <v-card-title
          v-else-if="cbExpirebientot"
          class="orange white--text subheading"
        >
          {{$t('warning')}}
          <br>
          {{$t('cbExpire5')}} {{delaiExpireCB}}
        </v-card-title> 
        <v-card-text>
          <h3> {{$t('cbExpire2')}} {{dateExpireLicence}}, {{$t('cbExpire3')}} </h3>
          <br />
          <p>{{$t('cbExpire4')}}</p>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="primary"
            @click="majCB()"
          >
            {{$t('majCb')}}
          </v-btn>
          <v-btn 
            class="blue--text darken-1"
            flat
            @click="continuerExpireCB()"
          >
            {{$t('continue')}}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- dialog backoffice inatif -->
    <v-dialog v-model="dialogConnexionInactive" persistent max-width="290">
      <v-card>
        <v-card-title class="primary white--text subheading">{{$t('sessionInactiv')}}</v-card-title>
        <v-card-text>
          <div v-html="$t('sessionInactivPopUp')" ></div>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn class="blue--text darken-1" flat @click="logout()">{{$t('no')}}</v-btn>
          <v-btn color="primary" @click="reactiveBO()">{{$t('yes')}}</v-btn>
          </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- dialog envoi de screenshot -->
    <v-dialog v-model="dialogBugScreenshot" max-width="450">
      <v-card>
        <v-card-title class="primary white--text subheading">{{ $t('sendFeedback') }}</v-card-title>
          <v-card-text>
          <v-textarea
              :label="$t('yourFeedback')"
              v-model="messageBug"
              required
              box
              ></v-textarea>
         <img :src="imageUrl" width="100%" height="auto">
       </v-card-text>
         <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn class="primary" :loading="sendingReport" @click="envoiBug()" :disabled="!messageBug.trim().length">
            {{ $t('send') }}
            <v-icon right>send</v-icon>
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- dialog trop d'agents connectés -->
    <v-dialog v-model="dialogTooMuchAgents" max-width="290" persistent>
      <v-card>
        <v-card-title class="primary white--text subheading">{{ $t('dashOups') }}</v-card-title>
        <!-- <v-card-text v-html="$tc('tooMuchAgentsConnected', 1, { count: $store.state._User.entNbAgent })"> -->
          <v-card-text>
            <div v-html="$tc('tooMuchAgentsConnected', 1, { count: $store.state._User.entNbAgent })"></div>
          </v-card-text>

        <v-card-actions>
          <v-btn
            block
            class="primary--text"
            flat
            @click="logout()"
          >
            {{ $t('logout') + ' (' + countdown + ' sec.)'}}
            <v-icon right>exit_to_app</v-icon>
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- dialog mise à jour de version -->
    <v-dialog v-model="dialogClearCache" max-width="500" persistent>
      <v-card>
        <v-card-title class="primary white--text subheading">{{ $t('cachetitle') }} : {{ versionBo }}</v-card-title>
        <v-card-text>{{ $t('cachecontent1') }}
          <br>{{ $t('cachecontent2') }} <a href='https://support.google.com/accounts/answer/32050?hl=fr&co=GENIE.Platform%3DDesktop' target='_blank'>{{ $t('cachecontent3') }}</a>{{ $t('cachecontent4') }}
          <br>{{ $t('cachecontent5') }}
        </v-card-text>
        <v-card-actions>
          <v-btn
            block
            class="primary--text"
            flat
            @click="reloadCache()"
          >
			{{ $t('reloadPage') }}
            <v-icon right>exit_to_app</v-icon>
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- dialog re-captcha -->
    <v-dialog v-model="showCaptcha"  max-width="500" persistent>
      <v-card>
        <v-card-title class="primary white--text subheading">Avant de commencer, merci de bien vouloir valider ce Captcha</v-card-title>
        <v-card-text>
        <div class="g-recaptcha" data-sitekey="6Lce06oiAAAAACoywsL9qjXF00_epPRvpDM-_1Rw"></div>
        </v-card-text>
        <v-card-actions>
          <v-btn
            block
            class="primary--text"
            flat
            @click="checkCaptcha()"
          >
			Vérifier
            <v-icon right>exit_to_app</v-icon>
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- dialog progress bar installation -->
    <v-dialog v-model="installProgress" max-width="850" persistent>
      <v-card>
        <v-card-title class="primary white--text subheading">{{ $t('visitGuidee') }}</v-card-title>
        <v-card-text>
          {{ $t('dash1') }}
          <br>{{ $t('dash2') }}
          <br><br>{{ $t('dash3') }}{{progress}}%.
          <div v-if="progress < 100">
            {{ $t('dash4') }}
          </div>
          <div v-else>
            {{ $t('dash7') }}
            <br>{{ $t('dash5') }}
          </div>
          <br>{{ $t('dash5') }}
          <v-container fluid grid-list-md>
            <v-layout row wrap>
              <v-flex xs6 md4>
                <img class="iconesAideTF" src="src/assets/img/tutos/icone_boussole.png"> <strong>{{ $t('visitGuidee') }}</strong>
              </v-flex>
              <v-flex xs6 md4> 
                <img class="iconesAideTF" src="src/assets/img/tutos/icone_chatbot.png"> <strong>{{ $t('dashChatbot') }}</strong>
              </v-flex>
              <v-flex xs6 md4>
                <img class="iconesAideTF" src="src/assets/img/tutos/icone_bug.png"> <strong>{{ $t('dashCenter') }}</strong>
              </v-flex>
              <v-flex xs6 md4>
                <img class="iconesAideTF" src="src/assets/img/tutos/icone_aide.png"> <strong>{{ $t('dashAide') }}</strong>
              </v-flex>
              <v-flex xs6 md4>
                <img class="iconesAideTF" src="src/assets/img/tutos/icone_notif.png"> <strong>{{ $t('dashNotif') }}</strong>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>
        <v-card-actions
          align="center"
        >
          <v-spacer></v-spacer>
          <v-layout row wrap>
              <v-flex xs6 md3>
                <v-btn v-if="!$vuetify.breakpoint.xsOnly" class="primary" @click="startTuto()">
                  {{ $t('dashCommencer') }}
                  <v-icon right>send</v-icon>
                </v-btn>
                <v-btn v-else class="primary" @click="startTuto()">
                  {{ $t('dashCommencer') }}
                </v-btn>
              </v-flex>
              <v-flex xs6 md3>
                <v-btn class="blue--text darken-1" flat @click="nextStep()" v-if="progress < 100"
                >
                  {{ $t('dashVoirSection') }}
                </v-btn>
              </v-flex>
              <v-flex xs6 md3>
                <v-btn class="blue--text darken-1" flat @click="skipTuto()"
                >
                  {{ $t('dashPasCetteFois') }}
                </v-btn>
              </v-flex>
              <v-flex xs6 md3>
                <v-btn class="blue--text darken-1" flat @click="blockTuto()"
                >
                  {{ $t('dashDontask') }}
                </v-btn>
              </v-flex>
          </v-layout>
          <!--<v-btn class="blue--text darken-1" flat @click="resetTuto()"
          >
            Recommencer depuis le début
          </v-btn>-->
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- module apizee pour gérer le webcall -->
    <WzModuleWebcallAPZ>
    </WzModuleWebcallAPZ>

  </v-app>
</template>

<script>
  import { mapGetters, mapState, mapMutations } from 'vuex'
  import moment from 'moment'
  // import Vue from 'vue'
  import Push from 'push.js'
  // import VueSocketIO from 'vue-socket.io'
  // import SocketIO from 'socket.io-client'
  // import socket from '@/plugins/socket'
  import _watcheebox from './watcheebox/watcheebox.js'
  import _ from 'lodash'
  import { DOMAINE, AWSS3_STATIC, VERSION_BO } from '../constants'
  import html2canvas from 'html2canvas'
  import compareVersions from 'compare-versions'
  import packagejson from '../../package.json'
  import WzModuleWebcallAPZ from './watcheezy/WzModuleWebcallAPZ'

  export default {
    components: { WzModuleWebcallAPZ },
    data () {
      return {
        // socket: socket,
        domaine: DOMAINE,
        messageBug: '',
        sendingReport: false,
        delaiExpireCB: '',
        expireCB: false,
        cbExpirebientot: false,
        activeDialogCB: false,
        // numMessageAttente: 0,
        // indique si le menu de gauche est affiché
        drawer: true,
        // indique si l'aide est affichée
        helper: false,
        // indique si le questionnaire de satisfaction agent est visible
        showSatisfactionAgent: false,
        // indique la taille du menu de droite
        mini: true,
        // intervalCheckFocus: null,
        idInterval: null,
        dialogTransfere: false,
        dialogReconnexion: false,
        dialogMultiConnexion: false,
        dialogBugScreenshot: false,
        dialogVisiteurOffline: false,
        visiteurChangePage: false,
        dialogConnexionInactive: false,
        activeDialogMultiSession: false,
        showCaptcha: false,
        /**
         * Vérification du nombre d'agents maximum connectés
         */
        dialogTooMuchAgents: false,
        dialogClearCache: false,
        countdown: 30,
        intervalTooMuchAgents: null,
        renouvellementDay: null,
        // Vérification du script
        dialogScript: false,
        isChecking: false,
        activeDialogPagesVues: false,
        fullQuotaPagesVues: false,
        fullQuotaChats: false,
        quotaPages: 0,
        quotaChats: 0,
        memoDialogQuota: '0',
        memoDialogC2C: '0',
        memoDialogExpireCB: '0',
        expireLicence: false,
        sursisLicence: false,
        LicenceOUT: false,
        usrBoNotif: '0',
        activeDialogc2c: false,
        depassementF: 0,
        depassementM: 0,
        C2CoffF: false,
        C2CnearF: false,
        C2CoffM: false,
        C2CnearM: false,
        c2cAverageF: 0,
        c2cAverageM: 0,
        resteEstimedF: 0,
        resteEstimedM: 0,
        visiteurSelectedTransfere: [],
        datasTransfere: {},
        navStatus: true,
        navConnexion: true,
        btConnexion: false,
        addVisiteur: false,
        supportEmail: 'support@targetfirst.com',
        supportAdress: 'https://support.targetfirst.com/',
        // socketLoaded: false,
        // gestion des sons
        // audioConnexion: document.createElement('audio'),
        audioOffline: document.createElement('audio'),
        audios: [
          { src_mp3: AWSS3_STATIC + '/sounds/offline.mp3' },
          { src_mp3: AWSS3_STATIC + '/sounds/ouverture1.mp3' }
        ],
        imageUrl: '',
        mySocket_ID: 0,
        dateOptions: { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric' },
        dateExpire: '',
        dateExpireLicence: '',
        installProgress: false,
        progress: this.$store.state._User.installProgress,
        versionBo: VERSION_BO,
        // timerFocusOFF: 0,
        secsRemaining: 60,
        timerReload: null,
        noMainSite: false,
        // timer: 21600, // c'est des secondes (6 heures (21600s))
        captcha: '',
        duration: 0,
        remaining: 0,
        elapsed: 0,
        isPageActive: true
      }
    },

    methods: {
      ...mapMutations('_StoreWatcheeBox', [
        'SOCKET_DISCONNECT_CLIENT',
        'SET_STATUS',
        'SET_STATUS_MANUALLY',
        'SET_TOO_MUCH_AGENTS_CHECKED',
        'CHANGE_VIEW_PUPITRE'
      ]),
      ...mapMutations(['SET_REASON_UNLOAD', 'SET_REASON_DECO']),
      ...mapMutations('_User', [
        'SET_ISMOBILE',
        'SET_ISMOBILEIOS',
        'SET_CONFIGURED'
      ]),
      viewSizeScreen () {
        if (this.$vuetify.breakpoint.xsOnly) {
          this.CHANGE_VIEW_PUPITRE(1)
        }
      },
      goBack () {
        this.$router.go(-1)
      },
      bugReport () {
        this.dialogBugScreenshot = true
        this.takeScreenshot()
      },
      mouseDown () {
        // l'agent est bien actif on met le timer à zéro
        // this.timerFocusOFF = 0
      },
      handleVisibilityChange () {
        this.isPageActive = document.visibilityState === 'visible'
        // console.log('Visibility changed:', this.isPageActive)
        this.checkFocus(this.isPageActive)
      },
      handleWindowFocus () {
        this.isPageActive = true
        // console.log('Window focused')
        this.checkFocus(this.isPageActive)
      },
      handleWindowBlur () {
        this.isPageActive = false
        // console.log('Window blurred')
        this.checkFocus(this.isPageActive)
      },
      async getSessionDuration () {
        try {
          const res = await this.axios.get('get/test_session_php.php', {
            withCredentials: true // indispensable pour envoyer le cookie PHPSESSID
          })
          console.log('getSessionDuration', res.data)
          this.duration = res.data.duration
          this.remaining = res.data.remaining
          this.elapsed = res.data.elapsed
        } catch (e) {
          console.error('Erreur récupération session :', e)
        }
      },

      startTimerReload () {
        // console.log('startTimerReload')
        this.secsRemaining = 60
        this.timerReload = setInterval(this.runTimerReload, 1000)
      },
      pauseTimerReload () {
        // console.log('pauseTimerReload')
        clearInterval(this.timerReload)
        this.timerReload = null
      },
      runTimerReload () {
        // console.log('runTimerReload', this.secsRemaining)
        if (this.secsRemaining <= 0) {
          this.pauseTimerReload()
          this.debloqueMultiSession()
        } else {
          this.secsRemaining = this.secsRemaining - 1
        }
      },
      formatTime (secs) {
        if (secs < 60) {
          return `0:${this.formatDigit(secs)}`
        } else {
          let minutes = Math.floor(secs / 60)
          let seconds = secs % 60
          return `${this.formatDigit(minutes)}:${this.formatDigit(seconds)}`
        }
      },
      formatDigit (num) {
        if (num < 10) {
          return `0${num}`
        } else if (num === 0) {
          return '00'
        } else {
          return num.toString()
        }
      },
      // check la version en cours du bo
      checkVersion () {
        // let packageJson = fs.realpathSync('./package.json')
        // let version = JSON.parse(packageJson).version || 0
        console.log('version installée actuellement ', VERSION_BO)
        // console.log('version', packageJson)
        // console.log('version disponible ', packagejson.version)
        // packagejson.forEach(x => { console.log('json : ', x) })
        if (compareVersions(packagejson.version, VERSION_BO)) {
          // this.dialogClearCache = true
        } else {
          console.log('BO à jour')
        }
      },
      // ce deconnecter du BO
      logout () {
        console.log('[dash] logout ')
        this.$store.dispatch('_StoreWatcheeBox/removeAllChatsSession', this.$socket) // vuex action
        // this.isLogout = true
        // _watcheebox.AgentLogout({
        //   datasAgent: this.user
        // })
        // this.axios
        //   .post('post/logout.php')
        //   .then(response => {
        //     // this.$store.dispatch('logout', this.$socket)
        //   })
        //   .catch()
      },

      // reprendre la main sur l'autre compte connecté au BO
      reconnexionAgent () {
        // this.rechargeLoadBalancer()
        _watcheebox.deconnexionSession({
          // 'socket': this.$socket,
          datasAgent: this.user
        })
      },

      // Si BO bloquer en multisession
      debloqueMultiSession () {
        // this.rechargeLoadBalancer()
        this.pauseTimerReload()
        _watcheebox.debloqueSession({
          // 'socket': this.$socket,
          datasAgent: this.user
        })
      },

      // -----------------------------------------------------
      // Calcul des dates
      // -----------------------------------------------------
      isLeapYear (year) {
        return (((year % 4 === 0) && (year % 100 !== 0)) || (year % 400 === 0))
      },
      getDaysInMonth (year, month) {
        return [31, (this.isLeapYear(year) ? 29 : 28), 31, 30, 31, 30, 31, 31, 30, 31, 30, 31][month]
      },
      addMonths (value, jour) {
        var n = new Date()
        // n.setMonth(3)
        // console.log('date', n)
        // si le jour est supperieur au 28 il faut regarder le nombre de jour maxi du mois en cours
        if (jour > 28) {
          n.setDate(Math.min(jour, this.getDaysInMonth(n.getFullYear(), n.getMonth())))
        } else {
          n.setDate(Math.min(jour, this.getDaysInMonth(n.getFullYear(), n.getMonth())))
          if (value) {
            n.setMonth(n.getMonth() + value)
          }
        }
        // console.log('final', n)
        // var WNbJours = n - new Date()
        // console.log('WNbJours', WNbJours)
        return n
      },
      diffDate (d1, d2) {
        // console.log('d1', d1)
        // console.log('d2', d2)
        var WNbJours = d2.getTime() - d1.getTime()
        return Math.ceil(WNbJours / (1000 * 60 * 60 * 24))
      },
      // -----------------------------------------------------

      rechargePages () {
        this.activeDialogPagesVues = false
        this.activeDialogc2c = false
        this.activeDialogCB = false
      },
      // si agent inactif sur le BO et réactivce sa session
      reactiveBO () {
        console.log('reactiveBO')
        // this.timerFocusOFF = 0
        this.rechargeLoadBalancer()
        this.dialogConnexionInactive = false
        // relance le timer pour checker le focus agent
        // this.intervalCheckFocus = setInterval(this.checkFocus, 1000) // check le focus toutes les secondes
      },

      checkRefFacturation (data) {
        let url
        // Si ily a un referent facturation
        if (this.$store.state._User.entRefFacturation) {
          // Si c'est moi le referent
          if (this.$store.state._User.entRefFacturation === this.$store.state._User.mail) {
            url = 'https://admin.targetfirst.com/subscription/subscriptions_fr.php'
          // Si le referent c'est pas moi
          } else {
            if (data.type === 'quotaPages') {
              url = 'https://support.targetfirst.com/2019/10/25/comment-souscrire-a-100-000-pages-trackees-supplementaires/'
            } else if (data.type === 'quotaC2C') {
              url = 'https://support.targetfirst.com/2019/10/25/comment-souscrire-a-un-credit-dheures-de-call-back-supplementaire/'
            } else if (data.type === 'expireCB') {
              url = 'https://support.targetfirst.com/2019/10/25/comment-mettre-a-jour-mes-coordonnees-de-carte-bancaire/'
            } else if (data.type === 'expireLicence') {
              url = 'https://support.targetfirst.com/2019/10/23/comment-renouveler-ma-licence/'
            } else if (data.type === 'expireCB') {
              url = 'https://support.targetfirst.com/2019/10/25/comment-mettre-a-jour-mes-coordonnees-de-carte-bancaire/'
            }
          }

        // Si il n'y a pas de referent facturation
        } else {
          // je peux en créer un
          url = 'https://support.targetfirst.com/2019/10/25/comment-creer-editer-mon-compte-de-facturation/'
        }
        return url
      },

      // -----------------------------------------------------
      // souscrire à des pages suplémentaire
      // -----------------------------------------------------
      souscrire () {
        this.activeDialogPagesVues = false
        window.open(this.checkRefFacturation({'type': 'quotaPages'}), 'souscription')
      },
      // -----------------------------------------------------
      // ferme la dialogbox pages vues
      // -----------------------------------------------------
      continuer () {
        this.activeDialogPagesVues = false

        this.SET_REASON_UNLOAD('L\'agent a vue le message d\'alert Quota et a fermer la fenetre')
        // memorise la fermeture pour la session
        this.$cookie.set('memoDialogQuota', '1', { expires: '10h' })
      },

      // -----------------------------------------------------
      // souscrire C2C
      // -----------------------------------------------------
      souscrireC2C () {
        this.activeDialogc2c = false
        window.open(this.checkRefFacturation({'type': 'quotaC2C'}), 'souscription')
      },
      // -----------------------------------------------------
      // ferme la dialogbox C2C
      // -----------------------------------------------------
      continuerC2C () {
        this.activeDialogc2c = false
        this.SET_REASON_UNLOAD('L\'agent a vue le message d\'alert Click to Call')
        // memorise la fermeture pour la session
        this.$cookie.set('memoDialogC2C', '1', { expires: '10h' })
      },

      majCB () {
        this.activeDialogCB = false
        window.open(this.checkRefFacturation({'type': 'expireCB'}), 'souscription')
      },
      continuerExpireCB () {
        this.activeDialogCB = false
        this.SET_REASON_UNLOAD('L\'agent a vue le message d\'alert de l\'expiration de la carte de crédit')
        // memorise la fermeture pour la session
        this.$cookie.set('memoDialogExpireCB', '1', { expires: '10h' })
      },

      /**
       * Vérifie que la ligne de code Watcheezy est bien installée
       */
      checkScript () {
        this.isChecking = true
        this.axios
          .get('get/check_script.php?key=' + this.$store.state._User.entKey)
          .then(res => {
            this.dialogScript = false
            this.$store.commit('_User/setEntNbPageTotal', 1)
            this.reconnexionBO('Ligne de script pas installée')
          })
          .catch(() => {
            this.SET_STATUS('offline')
          })
          .then(() => {
            this.isChecking = false
          })
      },

      // init les sounds de l'interface
      initSounds () {
        this.audioOffline.setAttribute('src', this.audios[0].src_mp3)
        this.audioOffline.load()
        // this.audioConnexion.setAttribute('src', this.audios[1].src_mp3)
        // this.audioConnexion.load()
      },

      // ---------------------------------------------------------
      // Test si le navigateur n'a plus de connexion internet
      // j'ajoute un timer de 10 secondes pour etres sur que la perte de connexion est definitive
      // exemple mise en veille
      // ---------------------------------------------------------
      // le navigateur est online
      isOnline () {
        // affiche le bouton 'reconnexion'
        this.btConnexion = true
        // si le navigateur n'est pas definitivement offline
        if (this.navConnexion) {
          // this.navStatus = true
        }
      },

      // le navigateur est offline
      isOffline () {
        this.navStatus = false
        this.btConnexion = false
        // on va attendre 10 secondes pour etres sur de la deconnexion
        setTimeout(() => {
          // si apres 10 seconde le navigateur n'a pas retrouvé la connexion à internet
          window.addEventListener('online', this.isOnline, false)
          if (!this.navStatus) {
            // il est consideré comme definitivement offline
            this.navConnexion = false
            // affiche la dialogueBox de reconnexion
            this.dialogReconnexion = true
          }
        }, 10000)
      },

      reconnexionBO (reason) {
        this.loadingDeco = true
        this.SET_REASON_UNLOAD('Dash: ' + reason)
        window.location.reload()
      },

      toggleMini () {
        this.mini = !this.mini
        this.$cookie.set('wz-mini', this.mini, { expires: '1Y' })
      },

      // ----------------------------------------------------------------------
      // FOCUS AGENT
      // l'agent est focus sur le backoffice watcheezy
      // ----------------------------------------------------------------------
      checkFocus (focusStatus) {
        // console.log('checkFocus ', window.lastFocusStatus)
        // uniquement si le socket est chargé
        if (this.mySocketID && this.$socket) {
          // if (document.hasFocus() === window.lastFocusStatus) {
          //   // si trop longtemps inactif, on affiche une dialogbox de reconnexion
          //   console.log(this.timerFocusOFF + ' >= ' + this.timer)
          //   if (this.timerFocusOFF >= this.timer) {
          //     // pour que ca marche il faut passer à true
          //     this.dialogConnexionInactive = true
          //     console.log('-------------------------------------------stop-------------------------------')
          //     window.clearInterval(this.intervalCheckFocus)
          //   }
          //   this.timerFocusOFF++
          //   // console.log('timerFocusOFF', this.timerFocusOFF)
          //   return
          // }
          // ca change on remet à zero
          // this.timerFocusOFF = 0
          // window.lastFocusStatus = !window.lastFocusStatus
          _watcheebox.changeFocusAgent({
            // 'socket': this.$socket,
            datasAgent: this.user,
            focusSessionID: this.WATCHEEBOX_STATE.focusPupitre.focusSessionID,
            focusAgent: focusStatus
          })
          this.$store.commit('_StoreWatcheeBox/AGENT_FOCUS', {
            myFocus: focusStatus
          })
          // if(focusSessionID){
          //   // Push.close(focusSessionID)// ferme la bonne notification
          // }
        }
      },

      // ----------------------------------------------------------------------------
      // Connexion de l'agent au serveur nodejs
      // Si on utilise cette fonction c'est que :
      // 1 - c'est la premiere connection au socket de l'agent
      // 2 - il est deja connecté au socket mais n'etait plus dans la room, alors au le rajoute à la room
      // ----------------------------------------------------------------------------
      connectAgent () {
        console.log('connectAgent', this.$store.state._User)
        // console.log('this.$socket.connected', this.$socket.connected)
        if (!this.$socket.connected) {
          console.log('l\'agent n\'est pas encore connecté')
          // if (this.$socket.recovered) {
          //   console.log('🔄 Reconnecté, messages récupérés !')
          // } else {
          //   console.log('✨ Nouvelle connexion ou pas de messages récupérés')
          // }
          // this.$store.dispatch('_StoreWatcheeBox/connectSocket')
          // console.log('this.statusManually', this.statusManually)
          // this.$store.commit('_StoreWatcheeBox/PLAY_SOUND_OPEN_BO') // son nouvelle conversation
          let user = this.$store.state._User
          // console.log('login user', user)
          user.status = this.statusManually ? this.statusManually : this.status // sinon on garde le status actuel
          // si il a des cles webPush
          // let storageKeyWebPush = window.localStorage.getItem('server-keys')
          // let storageSubscriptionWebPush = window.localStorage.getItem('server-subscription')
          // _watcheebox.connexionAgent({
          //   // 'socket': this.$socket,
          //   agentStatus: user.status,
          //   datasAgent: user, // les données agent
          //   agentName: this.fullName, // sont nom
          //   sessionPHP: this.$store.state._StoreWatcheeBox.sessionPHP, // sa sessionPHP
          //   // sid: undefined, // id server nodejs
          //   keyWebPush: storageKeyWebPush,
          //   subscriptionWebPush: storageSubscriptionWebPush
          // }) // Connexion de l'agent
        } else {
          // _.forEach(this.sessionsPrivees, (sessionChat, key) => {
          //   _watcheebox.clientConnectRoom({'socket': this.$socket, 'roomName': 'chat_' + sessionChat[1]})
          // })
          _watcheebox.clientRetourRoom({
            // 'socket': this.$socket,
            datasAgent: this.user,
            sessionPHP: this.$store.state._StoreWatcheeBox.sessionPHP // sa sessionPHP
          }) // Connexion de l'agent
          _watcheebox.changeStatusAgent({
            statut: this.status,
            agentID: this.user.id,
            sessionsPrivees: this.sessionsPrivees,
            roomName: this.user.entKey,
            sessionPHP: this.$store.state._StoreWatcheeBox.sessionPHP
            // 'socket': this.$socket
          })
        }
        // this.modifVisiteursNode()
      },

      // ----------------------------------------------------------------------
      // RECONNEXION AUTOMATIQUE AU SOCKET
      // on refais appel au loadBalancer pour avoir un nouveau DNS de nodejs dispo
      // ----------------------------------------------------------------------
      rechargeLoadBalancer: _.debounce(function () {
        console.log('## rechargeLoadBalancer', this.$socket)
        if (!this.$socket.connected) {
          console.log('🔄 Connexion socket…')
          this.$socket.connect()
        } else {
          console.log('🔵 CONNECTÉ → connexion agent')
          this.SET_STATUS(this.statusManually)
          this.connectAgent()
        }
      }, 1000),

      // ----------------------------------------------------------------------
      // Reconnect au morroring si deja connecté
      // ----------------------------------------------------------------------
      reconnectMirroring () {
        // console.log('reconnectMirroring')
        var index = _.findIndex(this.agentsArray, { 2: this.user.id })
        if (index !== -1) {
          // console.log('index', index)
          // let sessionMorriring = this.agentsArray[index][20] // session mirroring en cours
          // j'ai bien ma session cobrowsing en cours, maintenant il faut le reconnecter à la session
        }
      },

      // ----------------------------------------------------------------------
      // ferme la dialogBox du visiteur qui change de page
      // ----------------------------------------------------------------------
      closeDialogVisiteurChangePage () {
        this.dialogVisiteurOffline = false
        this.visiteurChangePage = false
      },

      // ----------------------------------------------------------------------
      // ferme le transfere de chat envoyé par un autre agent
      // si le visiteur n'est plus disponible dans "listeAllVisiteurs"
      // ----------------------------------------------------------------------
      closeTransfertClient () {
        this.closeDialogVisiteurChangePage()
        this.dialogTransfere = false
        _watcheebox.rejetTransfert({
          // 'socket': this.$socket,
          datasTransfere: this.datasTransfere
          // 'datasVisiteur': this.visiteurSelectedTransfere
        })
        // modification du store (demande de prise en charge refusé par moi)
        this.$store.commit('_StoreWatcheeBox/SOCKET_VISITOR_TRANSFERT', {
          status: 'NO',
          emission: false,
          messageDatas: ''
        })
      },

      // ----------------------------------------------------------------------
      // Rejet le transfere de chat envoyé par un autre agent
      // ----------------------------------------------------------------------
      rejetTransfertClient () {
        this.dialogTransfere = false
        _watcheebox.rejetTransfert({
          // 'socket': this.$socket,
          datasTransfere: this.datasTransfere
          // 'datasVisiteur': this.visiteurSelectedTransfere
        })
        // modification du store (demande de prise en charge refusé par moi)
        this.$store.commit('_StoreWatcheeBox/SOCKET_VISITOR_TRANSFERT', {
          status: 'NO',
          emission: false,
          messageDatas: ''
        })
      },

      // ----------------------------------------------------------------------
      // Accept le transfere de chat envoyé par un autre agent
      // ----------------------------------------------------------------------
      acceptTransfertClient () {
        // check si le visiteur transféré est toujours en ligne
        // car on ne peut pas transféré un visiteur offline
        // il faut bien faire la diference entre offline et changement de page
        let visiteurTransfert = this.listeAllVisiteurs.filter(visiteur => visiteur.visiteurID === this.datasTransfere.chatSession)
        // console.log('statusVisteurTransfert', visiteurTransfert)

        // si ce visiteur est toujours en ligne
        if (visiteurTransfert.length) {
          // il est en ligne mais change de page
          if (visiteurTransfert[0].connexion) {
            this.dialogTransfere = false
            // Il faut verifier que le socketId de l'agent qui envois cette invitation n'a pas changé
            // pour cela on va recuiperer le socketID dans listeAllVisiteurs
            let indexVisiteur = _.findIndex(this.WATCHEEBOX_STATE.agentsArray,
              { 2: this.$store.state._StoreWatcheeBox.transfertStatusReception.datas.senderID }
            )
            // c'est agent est dans la liste
            if (indexVisiteur !== -1) {
              // c'est le socketID de l'agent qui envois le transfert
              // recupere le socketID à jour de cet agent
              this.datasTransfere.clientSocketID = this.WATCHEEBOX_STATE.agentsArray[indexVisiteur][4]
            }
            _watcheebox.acceptTransfert({
              // 'socket': this.$socket,
              datasTransfere: this.datasTransfere
              // 'datasVisiteur': this.visiteurSelectedTransfere
            })
            // je vide l'histoChat pour etre sur d'avoir toutes les bulles de chat
            this.visiteurSelectedTransfere.histoChat = []
            // check les place dispo dans le pupitre
            var placeOccupe = []
            // parse le tableau pour trouve le visiteur et la place occupé
            _.forEach(
              this.WATCHEEBOX_STATE.listeAllVisiteurs,
              (allVisiteurs, key) => {
                if (allVisiteurs.placePupitre) {
                  placeOccupe.push(allVisiteurs.placePupitre)
                }
              }
            )

            // Si plus de places dispo dans le pupitre on l'ajoute en file d'attente
            if (placeOccupe.length > 3) {
              this.visiteurSelectedTransfere.timeStampArrive = Date.now()
              this.visiteurSelectedTransfere.fileAttente = this.user.id // ajoute l'id agent dans fileAttente
              this.visiteurSelectedTransfere.placePupitre = null
              // Si il reste de la place dans le pupitre
            } else {
              var placePupitre = [1, 2, 3, 4]
              var placesDispo = _.difference(placePupitre, placeOccupe)
              this.visiteurSelectedTransfere.fileAttente = null
              this.visiteurSelectedTransfere.placePupitre = placesDispo[0] // la premiere place dispo qui reste
            }
            this.$store.commit(
              '_StoreWatcheeBox/SET_VISITEURS',
              this.visiteurSelectedTransfere
            )
            var dataSession = [
              this.visiteurSelectedTransfere.socketID,
              this.visiteurSelectedTransfere.visiteurID,
              this.user.id,
              this.visiteurSelectedTransfere.visiteurID
            ]
            this.$store.commit('_StoreWatcheeBox/ADD_PRIVATE_SESSION_CHAT', {
              session: dataSession,
              visiteur: this.visiteurSelectedTransfere
            })
            this.$router.push({ path: '/trafic/chatting' })
            // connect l'agent à la room visiteur
            _watcheebox.clientConnectRoom({
              roomName: 'chat_' + this.visiteurSelectedTransfere.visiteurID
            })
            // modification du store (demande de prise en charge accepté par moi)
            this.$store.commit('_StoreWatcheeBox/SOCKET_VISITOR_TRANSFERT', {
              status: 'OK',
              emission: false,
              messageDatas: ''
            })
          // Si ce visiteur change de page
          } else {
            console.log('le visiteur n\'est plus connecté ou il change de page')
            this.dialogVisiteurOffline = true
            this.visiteurChangePage = true
          }
        // Si ce visiteur est partie ou n'est plus connecté
        } else {
          console.log('le visiteur n\'est plus la')
          this.dialogVisiteurOffline = true
        }
      },

      // Prendre un screenshot de l'ecran//
      takeScreenshot () {
        html2canvas(document.querySelector('body'))
          .then(canvas => {
            let croppedCanvas = document.createElement('canvas')
            let croppedCanvasContext = croppedCanvas.getContext('2d')
            croppedCanvas.width = window.innerWidth
            croppedCanvas.height = window.innerHeight
            croppedCanvasContext.drawImage(
              canvas,
              0,
              0,
              croppedCanvas.width,
              croppedCanvas.height,
              0,
              0,
              croppedCanvas.width,
              croppedCanvas.height
            )
            this.imageUrl = croppedCanvas.toDataURL()
          })
          .catch(e => {
            console.error('e', e)
          })
      },

      envoiBug () {
        let dataToPost = new window.FormData()
        dataToPost.append('to', this.supportEmail)
        dataToPost.append('ReplyTo', this.user.mailContact)
        dataToPost.append('fullName', this.fullName)
        dataToPost.append(
          'siteSelected',
          this.$store.state._Sites.sites[0].LIC_URL
        )
        dataToPost.append('subject', 'Envoi de screenshot')
        dataToPost.append('title', 'Demande de support')
        dataToPost.append('message', this.messageBug)
        dataToPost.append('image', this.imageUrl)
        dataToPost.append('url', this.$route.fullPath)
        this.sendingReport = true
        this.axios
          .post('post/email_support.php', dataToPost, {
            headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
          })
          .then(res => {
            this.emailSupportSend = true
            this.$store.dispatch('_Notifier/NEW_NOTIF', {
              message: this.$t('emailSent'),
              context: 'success'
            })
            this.dialogBugScreenshot = false
          })
          .catch(() => {
            this.$store.dispatch('_Notifier/NEW_NOTIF', {
              message: this.$t('emailFailure'),
              context: 'error'
            })
          })
          .then(() => {
            this.sendingReport = false
            this.messageBug = ''
          })
      },

      // ----------------------------------------------------------------------
      // Vérifie que le nombre d'agents max n'est pas atteint
      // ----------------------------------------------------------------------
      checkAgentsMaxOnline () {
        // Si l'on se connecte depuis l'admin
        if (this.user.connectFromAdmin) {
          return
        }
        // Récupère le nombre d'agents connectés hormis moi
        let agentsConnected = this.agentsArray.filter(agent => {
          return agent[4] !== '0' && agent[2] !== this.user.id
        })
        if (agentsConnected.length >= this.user.entNbAgent) {
          this.dialogTooMuchAgents = true
          this.SET_STATUS('offline')
          if (!this.intervalTooMuchAgents) {
            this.intervalTooMuchAgents = setInterval(() => {
              this.countdown--
              if (this.countdown === 0) {
                this.logout()
              }
              this.checkAgentsMaxOnline()
            }, 1000)
            // Récupère dans un premier temps la liste des emails à contacter
            let params = new window.FormData()
            params.append('id', this.user.entId)
            this.axios
              .post('post/account.php', params, {
                headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
              })
              .then(res => {
                let addresses = res.data.licences.map(licence => licence.email)
                addresses = _.uniq(addresses)
                let dataToPost = new window.FormData()
                let body = this.$tc('tooMuchAgentsConnected', 1, {
                  count: this.user.entNbAgent
                })
                let agentsConnectedString = agentsConnected
                  .map(agent => '<li>' + agent[2] + ' ' + agent[1] + '</li>')
                  .join('')
                // une erreur est survenue quand l'agent n s'est connecté
                body += `<br>`
                body += `${this.$t('error')} <br>`
                body += `${this.$tc('agents', 1, { count: '' })} : <b>${
                  this.user.id
                }</b> ${this.fullName} (${this.user.mail} )<br>`
                body += `<h3>${this.$t('connectedAgents')}</h3>`
                body += `<ul>${agentsConnectedString}</ul>`
                dataToPost.append(
                  'subject',
                  this.$t('limitSimultaneousAgentsReached')
                )
                dataToPost.append('body', body)
                dataToPost.append('sender', 'admin@targetfirst.com')
                dataToPost.append('addresses', JSON.stringify(addresses))
                this.axios.post('post/notify_by_email.php', dataToPost, {
                  headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
                })
              })
          }
        } else {
          if (this.intervalTooMuchAgents) {
            window.clearInterval(this.intervalTooMuchAgents)
          }
          this.dialogTooMuchAgents = false
          this.countdown = 30
          this.SET_TOO_MUCH_AGENTS_CHECKED(true)
        }
      },

      leaving () {
        console.log('leaving', this.reasonUnload)
        // l'agent recharge le BO
        // this.$store.commit('_StoreWatcheeBox/AGENT_RELOAD', {})
        // Efface toutes les notifications
        Push.clear()
        // Log la raison du départ de la page
        if (!this.reasonUnload) {
          this.SET_REASON_UNLOAD('F5 / close tab')
        }

        // ceci est déclanché apres la fermeture de la page par l'utilisateur
        // il n'est plus logé donc erreur 401
        // let params = new window.FormData()
        // params.append('user', this.fullName)
        // params.append('userId', this.user.id)
        // params.append('reason', this.reasonUnload)
        // // il y a une erreur 401 au moment de la deconnexion du bo avec ce fichier
        // // this.SET_REASON_UNLOAD(null)
        // this.axios.post('post/log_leaving.php', params, {
        //   headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
        // })
      },

      startTuto () {
        this.installProgress = false
        // this.$store.state._User.ongoingTuto = true
        // mise à jour du store _User
        this.$store.commit('_User/ONGOING_TUTO', {
          ongoingTuto: true
        })
        this.$cookie.delete('blockInstallProgress')
        if (this.$router.currentRoute.fullPath !== '/settings/preview') {
          this.$router.push({ path: '/settings/preview' })
        } else {
          this.$router.go(this.$router.currentRoute)
        }
        return false
      },

      nextStep () {
        this.installProgress = false
        // this.$store.state._User.ongoingTuto = true
        // mise à jour du store _User
        this.$store.commit('_User/ONGOING_TUTO', {
          ongoingTuto: false
        })

        let steps = JSON.parse(this.$store.state._User.remainingSteps)

        if (steps.length === 0) {
          alert('Vous avez exploré toutes les sections clés de votre Backoffice. Vous pouvez refaire un tour, ou mettre à jours vos règles de ciblage comportemental.')
          // this.$store.state._User.ongoingTuto = false
          // mise à jour du store _User
          this.$store.commit('_User/ONGOING_TUTO', {
            ongoingTuto: false
          })
        }
        _.forEach(steps, (key, val) => {
          if (key === 'INS_SETTINGS_PREVIEW') {
            this.$router.push({ path: '/settings/preview' })
            return false
          } else if (key === 'INS_SETTINGS_HORSLIGNE') {
            this.$router.push({ path: '/settings/absence' })
            return false
          } else if (key === 'INS_SETTINGS_CHAT') {
            this.$router.push({ path: '/settings/chat' })
            return false
          } else if (key === 'INS_MANAGEMENT_SITES') {
            this.$router.push({ path: '/management/sites' })
            return false
          } else if (key === 'INS_MANAGEMENT_CONSEILLERS') {
            this.$router.push({ path: '/management/agents' })
            return false
          } else if (key === 'INS_PROFILE') {
            this.$router.push({ path: '/profile' })
            return false
          } else if (key === 'INS_TARGET_FILTERS') {
            this.$router.push({ path: '/target/filters' })
            return false
          } else if (key === 'INS_ACCOUNT') {
            this.$router.push({ path: '/account' })
            return false
          } else if (key === 'INS_MEDIA_BIBLIOS') {
            this.$router.push({ path: '/media/biblios' })
            return false
          } else if (key === 'INS_FO_INSTALLED') {
            this.$router.push({ path: '/stats/audience' })
            return false
          }
        })
      },

      blockTuto () {
        this.installProgress = false
        // this.$store.state._User.ongoingTuto = false
        // mise à jour du store _User
        this.$store.commit('_User/ONGOING_TUTO', {
          ongoingTuto: false
        })
        this.$cookie.set('blockInstallProgress', '1', { expires: '100000h' })
      },

      skipTuto () {
        this.installProgress = false
        // this.$store.state._User.ongoingTuto = false
        // mise à jour du store _User
        this.$store.commit('_User/ONGOING_TUTO', {
          ongoingTuto: false
        })
        // this.$cookie.set('blockInstallProgress', '1', { expires: '12h' })
      },

      resetTuto () {
        this.installProgress = true
        this.$cookie.delete('blockInstallProgress')
        // this.$store.state._User.ongoingTuto = false
        // mise à jour du store _User
        this.$store.commit('_User/ONGOING_TUTO', {
          ongoingTuto: false
        })

        let dataToPost = new window.FormData()
        dataToPost.append('ENT_ID', this.$store.state._User.entId)

        this.axios
          .post('post/resetTuto.php', dataToPost, {
            headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
          })
          // les changements été pris en compte alors changement des valeurs de l'user géré par le store
          .then(response => {
            this.$store.state._User.remainingSteps = '["INS_SETTINGS_PREVIEW","INS_SETTINGS_HORSLIGNE","INS_SETTINGS_CHAT","INS_MANAGEMENT_SITES","INS_MANAGEMENT_CONSEILLERS","INS_PROFILE","INS_TARGET_FILTERS","INS_ACCOUNT","INS_MEDIA_BIBLIOS","INS_FO_INSTALLED"]'
            this.$store.state._User.installProgress = 0
            this.progress = 0
            this.startTuto()
            /* this.axios
              .post('post/logout.php')
              .then(response => {
                this.$store.dispatch('logout', this.$socket)
              }) */
          .catch()
          })
          .catch(_ => {
          })
          .then(_ => {
          })
      },

      showHideMydesk () {
        /* eslint-disable */
        if (typeof openPanel === 'function') {
          openPanel()
        }
        /* eslint-enable */
      },

      reloadCache () {
        this.$cookie.set('clearcache', '1', { expires: '100000h' })
        window.location.reload(true)
      },

      checkCaptcha () {
        /* eslint-disable */
        this.captcha = grecaptcha.getResponse()
        let dataToPost = new window.FormData()
        dataToPost.append('captcha', this.captcha)
        dataToPost.append('entid', this.user.entId)
        this.axios
          .post('post/check_captcha.php', dataToPost, {
            headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
          })
          .then(response => {
            this.$store.dispatch('_Notifier/NEW_NOTIF', {
              message: 'Captcha validé, merci.',
              context: 'success'
            })
            this.showCaptcha = false
            this.SET_CONFIGURED('1')
          })
          .catch(_ => {
            this.$store.dispatch('_Notifier/NEW_NOTIF', {
              message: 'Problème de captcha',
              context: 'error'
            })
          })
        /* eslint-enable */
      }
    },

    computed: {
      ...mapState('_Toolbar', ['back', 'tabs', 'title', 'subTitle']),
      ...mapState('_StoreWatcheeBox', [
        'listeAllVisiteurs',
        'transfertStatusReception',
        'newMessage',
        'lastMessage',
        'reconnexionSocket',
        'isConnected',
        'sessionsPrivees',
        'mySocketID',
        'listeChatAgent',
        'agentsArray',
        'status',
        'statusManually',
        'visiteurChatSelected',
        'tooMuchAgentsChecked',
        'sessionDejaActive',
        'multiSessionsAgent',
        'sessionPhpActive',
        'delogOldSession',
        'autoDelogMySession'
      ]),
      ...mapState(['reasonUnload']),
      // ...mapState('_User', []),
      ...mapGetters('_StoreWatcheeBox', ['WATCHEEBOX_STATE']),
      ...mapGetters('_User', ['user', 'fullName']),
      ...mapGetters(['logged']),
      ...mapState('_Sites', ['siteSelected']),
      // focus de l'agent
      myFocus () {
        // index 16 du tableau des agents c'est le status du focus
        var myStatusFocus = _.find(this.agentsArray, [2, this.user.id])
        if (myStatusFocus && myStatusFocus[16] && myStatusFocus[16] === 'true') {
          return true
        } else {
          return false
        }
      },
      remainingFormatted () {
        return moment.utc(this.remaining * 1000).format('HH:mm:ss')
      },
      // check si la licence est valide (si pas trouver '@' dans l'url)
      licenceURL () {
        console.log('--> licenceURL', this.$store.state._Sites.siteSelected)
        if (this.siteSelected && this.siteSelected.LIC_URL.indexOf('@') === -1) {
          return true
        } else {
          return false
        }
      },
      // temps avant rechargement du bo Si multisession
      formattedTime () {
        return this.formatTime(this.secsRemaining)
      },
      percentage () {
        const rawTimeFraction = this.secsRemaining / 60
        const result = rawTimeFraction - (1 / 60) * (1 - rawTimeFraction)
        return result >= 0 ? result : 0
      },

      // affiche la version actuelle
      myVersion () {
        return VERSION_BO
      },

      // retourne le nombre de messages en attente pour cet agent
      getMessageAttente () {
        let numMessageAttente = 0
        const user = this.$store.state._User

        // si je suis un super agent je recupere tous les messages en attente
        if (user.rights > 1) {
          _.forEach(user.colleagues || [], (agent) => {
            // Vérifie que agent.listeMessages existe avant de lire length
            numMessageAttente += (agent.listeMessages ? agent.listeMessages.length : 0)
          })
        } else {
          const myId = Number(user.id)
          const colleaguesListe = _.cloneDeep(user.colleagues || [])
          const index = _.findIndex(colleaguesListe, (o) => Number(o.USR_ID) === myId)

          if (index !== -1) {
            const messages = colleaguesListe[index].listeMessages || []
            numMessageAttente = messages.length
          }
        }

        return numMessageAttente
      },

      Domaine () {
        return `${DOMAINE}/subscription/subscriptions_fr.php`
      },

      Support () {
        return this.supportAdress
      },

      // activeDialogMultiSession () {
      //   console.log('this.sessionDejaActive', this.sessionDejaActive)
      //   if (this.sessionDejaActive || this.multiSessionsAgent) {
      //     if (this.dialogReconnexion) {
      //       return false
      //     } else {
      //       return true
      //     }
      //   }
      // },

      checkPHPsessionID () {
        // var sessionPHPID = _.find(this.agentsArray, [2, this.user.id])
        // console.log('il y a une session dans mon store 1 ', sessionPHPID)
        // sessionPHPID = sessionPHPID ? sessionPHPID[22] : null
        // console.log('il y a une session dans mon store 2 ', sessionPHPID)
        // console.log('sessionPhpActive', this.sessionPhpActive)
        // il faut interroger nodejs et recuperer le phpsessionid de l'agent

        // // var satusAgentNode = _.find(this.agentsArray, [2, this.user.id])[3]
        if (this.$cookie.get('PHPSESSID')) {
          // console.log('DASH :: il y a une session php')
          return (this.$cookie.get('PHPSESSID').slice(0, 10) === this.sessionPhpActive)
        } else {
          // console.log('DASH :: pas de session php')
          this.$router.push({ path: '/login' })
        }
      }
    },
    // check si la licence est valide (si pas trouver '@' dans l'url)
    licenceURL () {
      console.log('--> licenceURL', this.$store.state._Sites.siteSelected)
      const licUrl = this.siteSelected && this.siteSelected.LIC_URL
      if (typeof licUrl === 'string' && licUrl.indexOf('@') === -1) {
        return true
      } else {
        return false
      }
    },
    // temps avant rechargement du bo Si multisession
    formattedTime () {
      return this.formatTime(this.secsRemaining)
    },
    percentage () {
      const rawTimeFraction = this.secsRemaining / 60
      const result = rawTimeFraction - (1 / 60) * (1 - rawTimeFraction)
      return result >= 0 ? result : 0
    },

    watch: {
      // multisession agent autre navigateur
      sessionDejaActive (newValue, oldValue) {
        console.log('sessionDejaActive newValue', newValue)
        console.log('sessionDejaActive oldValue', oldValue)
        if (newValue) {
          this.activeDialogMultiSession = true
          // console.log('this.checkPHPsessionID', this.checkPHPsessionID)
          // if (!this.checkPHPsessionID) {
          //   this.startTimerReload()
          // }
        } else {
          this.activeDialogMultiSession = false
        }
      },
      // multisession agent même navigateur
      multiSessionsAgent (newValue) {
        console.log('multiSessionsAgent', newValue)
        if (newValue) {
          this.activeDialogMultiSession = true
          this.startTimerReload()
          // console.log('demmarre le timer', newValue)
        } else {
          this.activeDialogMultiSession = false
        }
      },
      // ----------------------------------------------------------------------------
      // Affiche une notification si visiteur deconnecté du chat
      // ----------------------------------------------------------------------------
      isConnected: function (val, oldVal) {
        // console.log('-> isConnected', val)
        if (!val) {
          console.log('-> isConnected no', val)
          let reason = !window.navigator.onLine
            ? 'Dash: Internet perdu'
            : 'Dash: nodeJS perdu'
          this.SET_REASON_UNLOAD(reason)
          this.leaving()
          // this.audioConnexion.pause()
          // this.audioConnexion.currentTime = 0
        } else {
          console.log('-> isConnected yes', val)
          this.$socket.connect() // on relance le socket
          this.connectAgent({}) // on relance la connexion de l'agent
          // this.audioConnexion.play().catch(() => {})
        }
        if (!val && !document.hasFocus()) {
          Push.create(`Déconnexion du chat`, {
            body: `La connexion avec le chat été perdue...`,
            tag: 'disconnected',
            icon: {
              x16: 'https://public.targetfirst.com/dist_prod_v2/static/img/logo_16.png',
              x32: 'https://public.targetfirst.com/dist_prod_v2/static/img/logo_32.png'
            },
            onClick: function () {
              window.focus() // redonne le focus
              this.close() // ferme la bonne notification
            }
          }).catch(() => {})
          this.audioOffline.play().catch(() => {})
        } else {
          this.audioOffline.pause()
          this.audioOffline.currentTime = 0
        }
      },

      status: function (v) {
        if (v === 'offline' && !document.hasFocus()) {
          // console.log('Push Dash', Push)
          let title = _.upperFirst(this.$t('offline'))
          let body = this.$t('noTargetingOffline')
          setTimeout(() => {
            if (this.status === 'offline') {
              Push.create(title, {
                body: body,
                tag: 'offline',
                icon: {
                  x16: 'https://public.targetfirst.com/dist_prod_v2/static/img/logo_16.png',
                  x32: 'https://public.targetfirst.com/dist_prod_v2/static/img/logo_32.png'
                },
                onClick: function () {
                  window.focus() // redonne le focus
                  this.close() // ferme la bonne notification
                }
              })
              this.audioOffline.play().catch(() => {})
            }
          }, 1000)
        } else {
          this.audioOffline.pause()
          this.audioOffline.currentTime = 0
        }
      },

      // sessionDejaActive: function (val, oldval) {
      //   console.log('sessionDejaActive', val)
      //   if (val) {
      //     this.dialogMultiConnexion = true
      //   }
      // },

      // Si l'ancienne session à bien été effacé
      // on recharge le loadbalancer
      delogOldSession: function (val, oldval) {
        console.log('delogOldSession', val)
        this.activeDialogMultiSession = false
        if (val) {
          this.rechargeLoadBalancer()
        }
      },

      // Une nouvelle session distante
      // me delog du BO
      autoDelogMySession: function (val, oldval) {
        // console.log('autoDelogMySession', val)
        if (val) {
          this.SET_REASON_DECO({
            'status': 'autoDeco',
            'title': this.$t('titleDialogMultiConnexion'),
            'content': this.$t('contentDialogMultiConnexion')
          })
          this.logout()
        }
      },

      // check mon socketID
      // TODO : remettre en ordre la multi connexion
      agentsArray: function (val, oldval) {
        // console.log(this.mySocketID + ' - ' + val)
        if (!this.tooMuchAgentsChecked) {
          this.checkAgentsMaxOnline()
        }
      },

      // ----------------------------------------------------------------------------
      // Reconnexion automatique au socket si client deconnecté
      // ----------------------------------------------------------------------------
      reconnexionSocket: function (val, oldVal) {
        console.log('-> reconnexionSocket', val)
        // Si la reconnexionSocket est a true
        if (val) {
          // this.$socket.close()
          this.rechargeLoadBalancer()
          // -------IMPORTANT --------------
          // il faut ici tester si je suis en cobrowsing avec un client
          // et si oui, il faut retablire la connexion au cobowsing
          this.reconnectMirroring()
        } else {
          // Si premiere connexion au socket, création de l'agent
          // this.connectAgent({'nodeReload': true})
        }
      },

      // ----------------------------------------------------------------------------
      // un agent vous transfere un visiteur
      // ----------------------------------------------------------------------------
      transfertStatusReception: function (val, oldval) {
        // reception d'un transfere visiteur d'un autre agent
        this.datasTransfere = val.datas
        if (val.status === 'transfere') {
          this.dialogTransfere = true
          this.$store.commit('_StoreWatcheeBox/PLAY_SOUND_CONVERSATION') // son nouvelle conversation
          // mise a jour des infos visiteur selectionné pour le transfere
          var index = _.findIndex(this.listeAllVisiteurs, {
            visiteurID: val.datas.chatSession
          })
          if (index !== -1) {
            this.visiteurSelectedTransfere = _.clone(
              this.listeAllVisiteurs[index]
            ) // clone le visiteur
          }
          // _.forEach(this.WATCHEEBOX_STATE.listeAllVisiteurs, (listeVisiteurs, key) => {
          //   // check dans le store quel visiteur est selectionné
          //   if (listeVisiteurs.visiteurID === val.datas.chatSession) {
          //     this.visiteurSelectedTransfere = _.clone(listeVisiteurs) // clone le visiteur
          //   }
          // })
        } else if (val.status === 'annuler') {
          this.dialogTransfere = false // cache la dialogueBox
          this.$store.commit('_StoreWatcheeBox/SET_TRANSFERE_STATUS', '')
        }
      },

      // ----------------------------------------------------------------------------
      // Au changement du status de l'agent : reconstruction des chat en cours
      // ----------------------------------------------------------------------------
      '$store.state._StoreWatcheeBox.mySocketID': function (val, oldVal) {
        this.$store.commit('_StoreWatcheeBox/CHECK_PRIVATE_SESSION_CHAT')
      },

      // ----------------------------------------------------------------------------
      // Regarde le nombre de sessions privées de l'agent
      // change sont status si le nombre de session est egale à sont nombre de chat total
      // ----------------------------------------------------------------------------
      sessionsPrivees: function (val, oldVal) {
        // si agent pas offline
        if (this.status !== 'offline') {
          // et qu'il n'est pas arrivé au nombre de chat max
          if (this.sessionsPrivees.length < this.user.chatsMax) {
            // _watcheebox.AgentStatut({'socket': this.$socket, 'status': 'online', 'idAgent': this.user.id})
            _watcheebox.changeStatusAgent({
              statut: this.statusManually,
              agentID: this.user.id,
              sessionsPrivees: this.sessionsPrivees,
              roomName: this.user.entKey,
              sessionPHP: this.$store.state._StoreWatcheeBox.sessionPHP
              // 'socket': this.$socket
            })
          } else {
            // _watcheebox.AgentStatut({'socket': this.$socket, 'status': 'busy', 'idAgent': this.user.id})
            _watcheebox.changeStatusAgent({
              statut: this.statusManually === 'offline' ? 'offline' : 'busy',
              agentID: this.user.id,
              sessionsPrivees: this.sessionsPrivees,
              roomName: this.user.entKey,
              sessionPHP: this.$store.state._StoreWatcheeBox.sessionPHP
              // 'socket': this.$socket
            })
          }
        }
      },

      '$route.name': function (val, oldVal) {
        if (val === 'chatting') {
          this.drawer = false
        }
        if (oldVal === 'chatting') {
          this.drawer = true
        }
      }
    },

    created () {
      // this.$on('myInfos', (data) => {
      //   console.log('retour myInfos', data)
      // })
      console.log('process.env.NODE_ENV --> ', process.env.NODE_ENV)
      // console.log('create :: this.activeDialogMultiSession', this.activeDialogMultiSession)
      // si format mobile on passe le pupitre à 1 chat
      if (this.$vuetify.breakpoint.xsOnly) {
        this.CHANGE_VIEW_PUPITRE(1)
      }
      this.activeDialogMultiSession = false
      // sur quel device est l'utilisateur et si sur ios
      this.SET_ISMOBILE(this.isMobile)
      // console.log('isMobileIOS', this.isMobileIOS)
      this.SET_ISMOBILEIOS(this.isMobileIOS)

      // Tests afin de savoir s'il s'agit d'une connexion depuis freshdesk en mode mobile (widget 400*700)
      // if (DOMAINE.indexOf('freshdeskmobile') !== -1 || (this.$route.query.fromfreshdeskmobile && !_.isNil(this.$route.query.fromfreshdeskmobile) && this.$route.query.fromfreshdeskmobile === '1')) { // || DOMAINE.indexOf('localhost') !== -1
      //   console.log('dash :: freshdesk mobile')
      //   this.SET_ISMOBILE(true)
      // } else {
      //   console.log('dash ::')
      //   // recupere le test "isMobile" dans la mixin "permissions" si utilisateur est sur mobile ou non
      //   this.SET_ISMOBILE(this.isMobile)
      // }
      // console.log('dash created :::  this.$store.state._User.isMobile', this.$store.state._User.isMobile)
      // console.log('dash created :::  this.isMobile', this.isMobile)

      window.addEventListener('beforeunload', this.leaving)
      window.addEventListener('unload', this.leaving)
      // this.resetTuto()
      this.checkVersion()
      this.$store.commit('_StoreWatcheeBox/CLOSE_MULTISESSION_AGENT')
      // console.log('dash created 2 :::  this.$store.state._User.isMobile', this.$store.state._User.isMobile)
    },

    mounted () {
      // Événement quand l'onglet devient visible ou caché
      document.addEventListener('visibilitychange', this.handleVisibilityChange)
      // Événements focus / blur sur la fenêtre
      window.addEventListener('focus', this.handleWindowFocus)
      window.addEventListener('blur', this.handleWindowBlur)
      // console.log('start dash')
      // check la durée de session php de l'utilisateur
      this.getSessionDuration()
      this.timerSession = setInterval(() => this.getSessionDuration(), 60000)
      // console.log('--------------------------------------------------')
      // console.log(this.$store.state._Sites.sites[0].LIC_URL)
      // console.log(this.$store.state._Sites.sites[0].LIC_URL.indexOf('@'))
      // console.log('--------------------------------------------------')
      // EST-CE QU'UN VRAI SITE EST ENREGISTRE ?(comptes freemium)
      if (this.$store.state._Sites.sites[0].LIC_URL.indexOf('@') !== -1) {
        this.noMainSite = true
      }
      // pour voir si l'agent est actif et clique sur la page
      addEventListener('click', this.mouseDown, false)
      // si sur mobile, pupitre uniquement à 1 et sans possibilité de changer
      // si freshdesk en iframe, pupitre uniquement à 1 et sans possibilité de changer
      if (this.isMobile || this.$store.state._User.connexionType === 'freshdesk' && this.$vuetify.breakpoint.xsOnly) {
        this.$store.commit('_StoreWatcheeBox/CHANGE_VIEW_PUPITRE', 1)
      }
      if (!this.$cookie.get('clearcache')) {
        // this.dialogClearCache = true
      }
      this.usrBoNotif = this.$store.state._User.usr_bo_notif
      this.memoDialogQuota = this.$cookie.get('memoDialogQuota')
      this.memoDialogC2C = this.$cookie.get('memoDialogC2C')
      this.memoDialogExpireCB = this.$cookie.get('memoDialogExpireCB')
      // uniquement si il y a une carte de credit enregistré
      if (this.$store.state._User.cbExpiration) {
        let maintenant = Date.now()
        let cbExpire = this.$store.state._User.cbExpiration.CLI_PAYBOX_EXPIRY
        // console.log('cbExpire', cbExpire)
        // calcule de la date de la CB
        let cb = moment.parseZone(cbExpire, 'MMYY').format('x')
        // si la date de la CB est superieur, donc encore valide
        if (cb > maintenant) {
          this.expireCB = false
          // compare la date avec aujourd'hui
          cb = (cb - maintenant) / 1000
          if (cb < 2592000) {
            // validitée de la carte inferieur à 30 jours
            this.cbExpirebientot = true
            if (this.memoDialogExpireCB === '1') {
              this.activeDialogCB = false
            } else {
              this.activeDialogCB = true
            }
          }
          // affiche la diference en jours
          // console.log('duration ', moment.duration(cb, 'seconds').humanize(true))
          this.delaiExpireCB = moment.duration(cb, 'seconds').humanize(true)
        } else {
          this.expireCB = true
          this.cbExpirebientot = false
          this.activeDialogCB = true
        }
        this.dateExpireLicence = moment(this.$store.state._User.entEezyExpiry).format('LL')
      }
      // -----------------------------------------------
      // CHARGE LE CHATBOT
      loadTf()
      // CAPTCHA
      reCaptcha()

      let appContent = document.getElementById('toolBarApp')
      const toolbarContent = appContent.getElementsByClassName('v-toolbar__content')[0]
      if (this.$store.state._User.connexionType !== 'freshdesk') {
        toolbarContent.classList.add('primary')
      }
      // -----------------------------------------------
      // initialisation du service worker
      if ('serviceWorker' in navigator && 'PushManager' in window) {
        console.log('Service Worker and Push is supported')
        let dir = process.env.NODE_ENV === 'development' ? '/watcheezy/' : '/'
        navigator.serviceWorker.register(dir + 'service-worker.js', {
          scope: '.' // <--- THIS BIT IS REQUIRED
        }).then((swReg) => {
          console.log('Service Worker is registered', swReg.scope)
        })
        .catch((error) => {
          console.error('Service Worker Error', error)
        })
      } else {
        console.warn('Push messaging is not supported')
      }
      // -----------------------------------------------

      // -----------------------------------------------
      // check si la ligne de script est installé sur le site
      if (this.$store.state._User.entNbPageTotal === 0 && this.$store.state._User.welcome === '') {
        this.SET_STATUS('offline')
        this.dialogScript = true
        return
      }

      // -----------------------------------------------
      // Pour les nouveaux clients freemium, à partir du 26/10/22, sils ont validé le captcha
      if (this.$store.state._User.configured === '0') {
        this.showCaptcha = true
      }

      // -----------------------------------------------
      // calcule le quota de pages vue
      if (this.$store.state._User.entNbPageThisMonth) {
        this.quotaPages = (100 * this.$store.state._User.entNbPageThisMonth) / this.$store.state._User.entNbPageMax
      }

      // -----------------------------------------------
      // calcule le quota de chats
      if (this.$store.state._User.entNbChatThisMonth) {
        this.quotaChats = (100 * this.$store.state._User.entNbChatThisMonth) / this.$store.state._User.entNbChatMax
      }

      // -----------------------------------------------
      // Pour le C2C
      if (this.$store.state._Sites.siteSelected) {
        let typeNotif
        let txtNotif
        let titreNotif
        let c2cConsoSecF = this.$store.state._Sites.siteSelected.c2c_conso_sec_f
        let c2cQuotaSitesF = this.$store.state._Sites.siteSelected.c2c_quota_sites_f * 3600
        let c2cConsoSecM = this.$store.state._Sites.siteSelected.c2c_conso_sec_m
        let c2cQuotaSitesM = this.$store.state._Sites.siteSelected.c2c_quota_sites_m * 3600

        this.c2cAverageF = this.$store.state._Sites.siteSelected.c2c_average_f
        this.c2cAverageM = this.$store.state._Sites.siteSelected.c2c_average_m

        let resteF = 0 /* en sec */
        let resteM = 0

        if (c2cQuotaSitesF) {
          this.depassementF = Math.round(c2cConsoSecF * 100 / c2cQuotaSitesF)
          resteF = c2cQuotaSitesF - c2cConsoSecF
        } else {
          this.depassementF = 0
        }
        if (c2cQuotaSitesM) {
          this.depassementM = Math.round(c2cConsoSecM * 100 / c2cQuotaSitesM)
          resteM = c2cQuotaSitesM - c2cConsoSecM
        } else {
          this.depassementM = 0
        }

        // estimationdes jours restants
        if (this.c2cAverageF !== '' && this.c2cAverageF !== 0) {
          if (resteF > this.c2cAverageF) {
            this.resteEstimedF = Math.trunc(resteF / this.c2cAverageF)
          }
        }
        if (this.c2cAverageM !== '' && this.c2cAverageM !== 0) {
          if (resteM > this.c2cAverageM) {
            this.resteEstimedM = Math.trunc(resteM / this.c2cAverageM)
          }
        }

        txtNotif = this.$t('infoConsumptionC2C') + ((this.depassementF > this.depassementM) ? this.depassementF : this.depassementM) + ' %'

        // Depassement ou proche dépassement Fixe & Mobile
        if ((c2cConsoSecF > c2cQuotaSitesF && this.depassementF) || (c2cConsoSecM > c2cQuotaSitesM && this.depassementM)) {
          typeNotif = 'error'
          titreNotif = this.$t('warningC2C')
          this.activeDialogc2c = true
          this.C2CoffF = true
        } else if ((c2cConsoSecF > c2cQuotaSitesF * 0.8 && this.depassementF) || (c2cConsoSecM > c2cQuotaSitesM * 0.8 && this.depassementM)) {
          if ((this.resteEstimedF > 0 && this.resteEstimedF < 8) || (this.resteEstimedM > 0 && this.resteEstimedM < 8)) {
            typeNotif = 'phone_in_talk'
            titreNotif = this.$t('warningC2Cnear2')
            if (this.memoDialogC2C === '1') {
              this.activeDialogc2c = false
              this.C2CnearF = false
            } else {
              this.activeDialogc2c = true
              this.C2CnearF = true
            }
          }
        }

        // Depassement ou proche dépassement Mobile
        // if (c2cConsoSecM > c2cQuotaSitesM) {
          // typeNotif = 'error'
          // titreNotif = this.$t('warningC2C')
          // this.activeDialogc2c = true
          // this.C2CoffM = true
        // } else if (c2cConsoSecM > c2cQuotaSitesM * 0.8) {
          // typeNotif = 'phone_in_talk'
          // titreNotif = this.$t('warningC2Cnear2')
          // if (this.memoDialogC2C === '1') {
            // this.activeDialogc2c = false
            // this.C2CnearM = false
          // } else {
            // this.activeDialogc2c = true
            // this.C2CnearM = true
          // }
        // }

        // Notif center : proche dépassement Mobile ou Fixe
        if (this.depassementF > 80 || this.depassementM > 80) {
          // on ajoute une notif uniquemeent dans le notif center sans l'afficher
          this.$store.dispatch('_Notifier/NEW_NOTIF', {
            message: '',
            type: typeNotif, // c'est le nom de l'icone
            vu: true,
            // url: 'https://admin.targetfirst.com/subscription/subscriptions_fr.php',
            target: '_blank',
            data: {
              titre: titreNotif,
              url: this.checkRefFacturation({'type': 'quotaC2C'}),
              message: txtNotif,
              timestamp: Date.now()
            }
          })
        }
      }

      // -----------------------------------------------
      // date d'expiration
      if (this.$store.state._User.entEezyExpiry) {
        let now = Date.now()
        let dateExpireLicence = Date.parse(this.$store.state._User.entEezyExpiry)
        let event = new Date(this.$store.state._User.entEezyExpiry)
        let dif = ((dateExpireLicence / 1000) - (now / 1000)) / 86400
        let validate = Math.sign(dif)
        // si la licence n'a pas expirée et que le quota n'est pas dépassé
        if (validate !== -1 && this.quotaPages < 100 && this.quotaChats < 100) {
          // mais elle n'est plus active pour X raisons
          if (this.$store.state._User.entLevel === '0') {
            // console.log('Votre licence a été coupée')
            this.LicenceOUT = true
            this.activeDialogPagesVues = true
            this.SET_STATUS('offline')
            // on ajoute une notif uniquemeent dans le notif center sans l'afficher
            let txtNotif = this.$t('txtNotifContactSupport') + ' <b>' + this.supportEmail + '</b>'
            this.$store.dispatch('_Notifier/NEW_NOTIF', {
              message: '',
              type: 'error', // c'est le nom de l'icone
              vu: true,
              url: this.supportAdress,
              target: '_blank',
              data: {
                titre: this.$t('warningLicence'),
                message: txtNotif,
                timestamp: Date.now()
              }
            })
            return
          // elle encore active
          } else {
            this.expireLicence = false
            this.sursisLicence = false
            if (Math.ceil(dif) > 30) {
              // console.log('Votre licence est encore valide : ' + Math.ceil(dif) + ' jours')
            } else if (Math.ceil(dif) < 30) {
              // console.log('Attention votre licence est encore valide : ' + Math.ceil(dif) + ' jours')
            } else if (Math.ceil(dif) < 7) {
              // console.log('Alerte votre licence est encore valide : ' + Math.ceil(dif) + ' jours')
            }
          }
        // si licence valide mais quotaPages dépassé
        } else if (validate !== -1 && this.quotaPages >= 100 && this.quotaChats < 100) {
          // mais elle n'est plus active car quota dépassé
          if (this.$store.state._User.entLevel === '0') {
            // ne rien faire ici, c'est plus bas au niveau des quotas de pages
          }
        // si licence valide mais quotaChats dépassé
        } else if (validate !== -1 && this.quotaPages < 100 && this.quotaChats >= 100) {
          // mais elle n'est plus active car quotaChats dépassé
          if (this.$store.state._User.entLevel === '0') {
            // ne rien faire ici, c'est plus bas au niveau des quotas de pages
          }
        // si la date est depassée
        } else if (validate === -1 && this.quotaPages < 100 && this.quotaChats < 100) {
          // si le entLevel est à 0 la licence n'est plus active
          // si le entLevel n'est pas à '0' il y a un surcis avant expiration
          this.activeDialogPagesVues = true
          this.dateExpire = event.toLocaleDateString(this.$store.state._User.lang + '-' + this.$store.state._User.lang.toUpperCase(), this.dateOptions)
          if (this.$store.state._User.entLevel === '0') {
            // console.log('Votre licence n\'est plus valide depuis : ' + Math.ceil(dif) + ' jours')
            this.expireLicence = true
            // console.log('this.dateExpire', this.dateExpire)
            this.SET_STATUS('offline')
            // on ajoute une notif uniquemeent dans le notif center sans l'afficher
            let txtNotif = this.$t('txtNotifExpire') + ' ' + this.dateExpire
            this.$store.dispatch('_Notifier/NEW_NOTIF', {
              message: '',
              type: 'error', // c'est le nom de l'icone
              vu: true,
              url: '/account',
              data: {
                titre: this.$t('warningExpired'),
                url: this.checkRefFacturation({'type': 'expireLicence'}),
                message: txtNotif,
                timestamp: Date.now()
              }
            })
            return
          } else {
            // si il n'y a pas de jours de sursis
            if (this.$store.state._User.surcisLicience === '0') {
              // On coupe le chat
              this.expireLicence = true
              this.SET_STATUS('offline')
              // on ajoute une notif uniquemeent dans le notif center sans l'afficher
              let txtNotif = this.$t('txtNotifExpire') + ' ' + this.dateExpire
              this.$store.dispatch('_Notifier/NEW_NOTIF', {
                message: '',
                type: 'error', // c'est le nom de l'icone
                vu: true,
                url: '/account',
                data: {
                  titre: this.$t('warningLicence'),
                  url: this.checkRefFacturation({'type': 'expireLicence'}),
                  message: txtNotif,
                  timestamp: Date.now()
                }
              })
              return
            // Si il y a sursis
            } else {
              this.sursisLicence = true
              // on ajoute une notif uniquemeent dans le notif center sans l'afficher
              let txtNotif = this.$t('txtNotifExpire') + ' ' + this.dateExpire
              this.$store.dispatch('_Notifier/NEW_NOTIF', {
                message: '',
                type: 'error', // c'est le nom de l'icone
                vu: true,
                url: '/account',
                data: {
                  titre: this.$t('warningExpired'),
                  url: this.checkRefFacturation({'type': 'expireLicence'}),
                  message: txtNotif,
                  timestamp: Date.now()
                }
              })
            }
            // if (this.memoDialogQuota === '0') {
            // }
            // console.log('La date de rénouvellement est dépassée depuis : ' + Math.ceil(dif) + ' jours')
            // console.log('Mais la licence n\'a pas encore expirée (un surcis de quelques jours)')
          }
        }
      }

      // -----------------------------------------------
      // calcule le quota de pages vue uniquement su business model 'pv' (page vue)
      // this.$store.state._User.entBusiness --> business model 'pv' ou 'chat'
      if (this.$store.state._User.entNbPageThisMonth && !this.expireLicence && this.$store.state._User.entBusiness === 'pv') {
        // this.quotaPages = (100 * this.$store.state._User.entNbPageThisMonth) / this.$store.state._User.entNbPageMax

        let DateNow = new Date().getDate()
        let renouvellementDate = new Date(this.$store.state._User.entEezyExpiry).getDate()
        // let renouvellementDate = 7
        let dateInMonth
        // si la date d'aujourd'hui est plus grande que la date de renouvellement
        if (DateNow > renouvellementDate) {
          // il faut changer la date de reference au mois prochain
          dateInMonth = this.addMonths(1, renouvellementDate)
          this.renouvellementDay = this.diffDate(new Date(), dateInMonth)
        } else if (DateNow < renouvellementDate) {
          // this.renouvellementDay = renouvellementDate - DateNow
          dateInMonth = this.addMonths(0, renouvellementDate)
          this.renouvellementDay = this.diffDate(new Date(), dateInMonth)
        } else {
          this.renouvellementDay = 0
        }
        // console.log('dateInMonth', dateInMonth)
        // console.log('jours restants', this.renouvellementDay)

        // à partir de 80 %
        if (this.quotaPages >= 80 && this.quotaPages < 90) {
          // affiche si pas encore de cookie qui bloque l'affichage
          // if (this.memoDialogQuota === '0') {
          // console.log('bientôt la fin : votre quota de pages vues est de ' + this.quotaPages.toFixed(2) + '%')
          let txtNotif = this.$t('txtNotifQuota') + ' <b>' + this.quotaPages.toFixed(2) + ' %</b> ' + this.$t('txt2InfoQuota')
          this.$store.dispatch('_Notifier/NEW_NOTIF', {
            message: this.$t('txt1NotifQuota') + ' ' + this.quotaPages.toFixed(2) + ' %, ' + this.$t('txt2NotifQuota') + ' ' + this.$store.state._User.entNbPageThisMonth + ' ' + this.$t('outOf') + ' ' + this.$store.state._User.entNbPageMax + ' ' + this.$t('trackedPages') + '.',
            context: 'warning',
            position: 'top',
            color: 'orange',
            multiLine: true,
            timeout: 120000,
            target: '_blank',
            type: 'collections', // c'est le nom de l'icone
            vu: false,
            data: {
              titre: this.$t('titleNotifQuota'),
              message: txtNotif,
              url: this.checkRefFacturation({'type': 'quotaPages'}),
              timestamp: Date.now()
            }
          })
          // }
          // return
        // entre 90 % et 100 %
        } else if (this.quotaPages >= 90 && this.quotaPages < 100) {
          // console.log('Attention : votre quota de pages vues est de ' + this.quotaPages.toFixed(2) + '%')
          if (!this.memoDialogQuota || this.memoDialogQuota === '0') {
            this.activeDialogPagesVues = true
          }
          // on ajoute une notif uniquemeent dans le notif center sans l'afficher
          let txtNotif = this.$t('txtNotifQuota') + ' <b>' + this.quotaPages.toFixed(2) + ' %</b> ' + this.$t('txt2InfoQuota')
          this.$store.dispatch('_Notifier/NEW_NOTIF', {
            message: '',
            target: '_blank',
            type: 'collections', // c'est le nom de l'icone
            vu: true,
            data: {
              titre: this.$t('titleNotifQuota'),
              message: txtNotif,
              url: this.checkRefFacturation({'type': 'quotaPages'}),
              timestamp: Date.now()
            }
          })
        // plus de 100 %
        } else if (this.quotaPages >= 100) {
          // console.log('ALERTE : votre quota de pages vues est de ' + this.quotaPages.toFixed(2) + '%')
          this.activeDialogPagesVues = true
          this.fullQuotaPagesVues = true
          // on ajoute une notif uniquemeent dans le notif center sans l'afficher
          let txtNotif = this.$t('txtNotifQuota') + ' <b>100 %</b> ' + this.$t('txt2InfoQuota')
          this.$store.dispatch('_Notifier/NEW_NOTIF', {
            message: '',
            type: 'error', // c'est le nom de l'icone
            vu: true,
            url: '/account',
            data: {
              titre: this.$t('warningLicence'),
              message: txtNotif,
              url: this.checkRefFacturation({'type': 'quotaPages'}),
              timestamp: Date.now()
            }
          })
          return
        }
      }

      // -----------------------------------------------
      // calcule le quota de Chats uniquement su business model 'chat' (chat max)
      // this.$store.state._User.entBusiness --> business model 'pv' ou 'chat'
      if (this.$store.state._User.entNbChatThisMonth && !this.expireLicence && this.$store.state._User.entBusiness === 'chat') {
        let DateNow = new Date().getDate()
        let renouvellementDate = new Date(this.$store.state._User.entEezyExpiry).getDate()
        // let renouvellementDate = 7
        let dateInMonth
        // si la date d'aujourd'hui est plus grande que la date de renouvellement
        if (DateNow > renouvellementDate) {
          // il faut changer la date de reference au mois prochain
          dateInMonth = this.addMonths(1, renouvellementDate)
          this.renouvellementDay = this.diffDate(new Date(), dateInMonth)
        } else if (DateNow < renouvellementDate) {
          // this.renouvellementDay = renouvellementDate - DateNow
          dateInMonth = this.addMonths(0, renouvellementDate)
          this.renouvellementDay = this.diffDate(new Date(), dateInMonth)
        } else {
          this.renouvellementDay = 0
        }
        // console.log('dateInMonth', dateInMonth)
        // console.log('jours restants', this.renouvellementDay)

        // à partir de 80 %
        if (this.quotaChats >= 80 && this.quotaChats < 90) {
          // affiche si pas encore de cookie qui bloque l'affichage
          // if (this.memoDialogQuota === '0') {
          // console.log('bientôt la fin : votre quota de pages vues est de ' + this.quotaPages.toFixed(2) + '%')
          let txtNotif = this.$t('txtNotifQuota') + ' <b>' + this.quotaChats.toFixed(2) + ' %</b> ' + this.$t('txt2InfoQuotaChats')
          this.$store.dispatch('_Notifier/NEW_NOTIF', {
            message: this.$t('txt1NotifQuotaChat') + ' ' + this.quotaChats.toFixed(2) + ' %, ' + this.$t('txt2NotifQuota') + ' ' + this.$store.state._User.entNbChatThisMonth + ' ' + this.$t('outOf') + ' ' + this.$store.state._User.entNbChatMax + ' ' + this.$t('trackedChats') + '.',
            context: 'warning',
            position: 'top',
            color: 'orange',
            multiLine: true,
            timeout: 120000,
            target: '_blank',
            type: 'collections', // c'est le nom de l'icone
            vu: false,
            data: {
              titre: this.$t('titleNotifQuotaChat'),
              message: txtNotif,
              url: this.checkRefFacturation({'type': 'quotaPages'}),
              timestamp: Date.now()
            }
          })
          // }
          // return
        // entre 90 % et 100 %
        } else if (this.quotaChats >= 90 && this.quotaChats < 100) {
          // console.log('Attention : votre quota de pages vues est de ' + this.quotaPages.toFixed(2) + '%')
          if (!this.memoDialogQuota || this.memoDialogQuota === '0') {
            this.activeDialogPagesVues = true
          }
          // on ajoute une notif uniquemeent dans le notif center sans l'afficher
          let txtNotif = this.$t('txtNotifQuota') + ' <b>' + this.quotaChats.toFixed(2) + ' %</b> ' + this.$t('txt2InfoQuotaChats')
          this.$store.dispatch('_Notifier/NEW_NOTIF', {
            message: '',
            target: '_blank',
            type: 'collections', // c'est le nom de l'icone
            vu: true,
            data: {
              titre: this.$t('titleNotifQuotaChat'),
              message: txtNotif,
              url: this.checkRefFacturation({'type': 'quotaPages'}),
              timestamp: Date.now()
            }
          })
        // plus de 100 %
        } else if (this.quotaChats >= 100) {
          // console.log('ALERTE : votre quota de pages vues est de ' + this.quotaPages.toFixed(2) + '%')
          this.activeDialogPagesVues = true
          this.fullQuotaChats = true
          // on ajoute une notif uniquemeent dans le notif center sans l'afficher
          let txtNotif = this.$t('txtNotifQuota') + ' <b>100 %</b> ' + this.$t('txt2InfoQuotaChats')
          this.$store.dispatch('_Notifier/NEW_NOTIF', {
            message: '',
            type: 'error', // c'est le nom de l'icone
            vu: true,
            url: '/account',
            data: {
              titre: this.$t('warningLicence'),
              message: txtNotif,
              url: this.checkRefFacturation({'type': 'quotaPages'}),
              timestamp: Date.now()
            }
          })
          return
        }
      }

      // Dans le cas où l'agent est admin :
      // - n'a pas accès au chat
      if (
        ['peon', 'agent', 'super', 'adminTF'].indexOf(
          this.$store.getters['_User/account'].role
        ) === -1
      ) {
        console.log
        this.SET_STATUS('offline')
        return
      }

      // Si l'on se connecte depuis l'admin
      if (this.$store.state._User.connectFromAdmin) {
        this.SET_STATUS('offline')
      }

      // Si l'option de se connecter 'en ligne"
      // n'est pas cochée sur la page de login
      if (!this.$store.state._User.connectingOnline) {
        this.SET_STATUS('offline')
      }

      /**
       * Si pas de statut manuel de l'agent
       * alors on prend celui de la case à cocher de la page login
       */
      if (!this.statusManually) {
        this.SET_STATUS_MANUALLY(this.status)
      }

      // -----------------------------------------------
      // --- IMPORTANT ---
      // -----------------------------------------------
      // regarde si l'object socket existe avant de la créer afin de ne pas avoir un doublon
      // si il n'existe pas encore, on se connect au serveur pour créer l'object socket
      console.log('this.$socket', this.$socket)
      // Lance la connexion socket APRES LOGIN
      this.$socket.connect()
      // this.connectAgent({})

      // if (this.$socket === undefined) {
        // console.log('pas de socket dispo')
      //   // Connexion automatique de l'agent au serveur nodejs de chat
      //   this.rechargeLoadBalancer()

      //   // Si l'obect socket existe déjà, on reconnect à la room le client
      //   // sans repasser par le processus de creation de l'object socket
      // } else {
      //   // Si l'agent est deja créé (c'est une reconnexion au BO), ajoute de l'agent dans la roomName
      //   this.connectAgent({})
      // }

      // check le focus de l'agent sur le BO
      window.lastFocusStatus = true
      // this.checkFocus()
      // this.intervalCheckFocus = setInterval(this.checkFocus, 1000) // check le focus toutes les secondes

      // check la connexion à internet du navigateur
      if (window.addEventListener) {
        window.addEventListener('online', this.isOnline, false)
        window.addEventListener('offline', this.isOffline, false)
      } else {
        // ca c'est pour IE uniquement
        document.body.ononline = this.isOnline
        document.body.onoffline = this.isOffline
      }

      // TUTORIEL
      if (this.checkPermission('NO_AGENTS') && this.$store.state._User.installProgress < 100 && !this.$cookie.get('blockInstallProgress') && !this.$store.state._User.ongoingTuto && !this.$store.state._User.tutoQuited) {
        // afficher si pas mobile
        if (!this.isMobile) {
          this.installProgress = true
          // this.$store.state._User.ongoingTuto = true
          // mise à jour du store _User
          this.$store.commit('_User/ONGOING_TUTO', {
            ongoingTuto: true
          })
          this.progress = this.$store.state._User.installProgress
        } else {
          this.installProgress = false
        }
      }
    },

    beforeUnmount () {
      document.removeEventListener('visibilitychange', this.handleVisibilityChange)
      window.removeEventListener('focus', this.handleWindowFocus)
      window.removeEventListener('blur', this.handleWindowBlur)
    },

    beforeDestroy () {
      clearInterval(this.timerSession)
      // this.$off('myInfos') // Évitez les fuites de mémoire
      // Si l'agent se deconnect du BO et retourne sur la page login
      // Il faut juste le virer de la room dans laquelle il ce  trouvait
      // this.SOCKET_DISCONNECT_CLIENT()
      // window.clearInterval(this.intervalCheckFocus)
      window.clearInterval(this.intervalTooMuchAgents)
      window.clearInterval(this.idInterval)
    }
  }

  function loadTf () {
    var tf = document.createElement('script')
    tf.type = 'text/javascript'
    tf.async = true
    tf.src = document.location.protocol + '//public.targetfirst.com/deliver/targetfirst.js?wzkey=backoffice2022'
    var s = document.getElementsByTagName('script')[0]
    s.parentNode.insertBefore(tf, s)
  }

  function reCaptcha () {
    var tf = document.createElement('script')
    tf.type = 'text/javascript'
    tf.async = true
    tf.src = document.location.protocol + '//www.google.com/recaptcha/api.js'
    var s = document.getElementsByTagName('script')[0]
    s.parentNode.insertBefore(tf, s)
  }

</script>

<style scoped>
  .badgeTopMenu{top: -10px;}
</style>

<style>
  .v-tooltip {display: contents !important}
  .v-menu {display: inline-block !important;}
  .row {margin: 0 !important;}
  .v-navigation-drawer .v-list {background: inherit !important;}
  .WatchBox-conversation .txtChat {width: calc(100% - 24px) !important;}
  .v-btn--bottom {bottom: 16px;}
  .sessionTimer {
    text-align: center;
    font-size: 0.8em;
    bottom: 40px;
    position: absolute;
    width: 100%;
    color:rgb(197, 197, 197)
  }
</style>



// WEBPACK FOOTER //
// src/components/Dash.vue